var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _g, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlog1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M900 0H0V600H900V0Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M758.998 450.119H141.936C133.135 450.119 126 457.254 126 466.056C126 474.858 133.135 481.993 141.936 481.993H215.299C224.1 481.993 231.235 489.128 231.235 497.929C231.235 506.731 224.1 513.866 215.299 513.866H170.082C161.281 513.866 154.145 521.001 154.145 529.803C154.145 538.604 161.28 545.739 170.082 545.739H748.765C757.567 545.739 764.702 538.604 764.702 529.803C764.702 521.001 757.567 513.866 748.765 513.866H746.265C737.464 513.866 730.328 506.731 730.328 497.929C730.328 489.128 737.464 481.993 746.265 481.993H758.998C767.8 481.993 774.935 474.858 774.935 466.056C774.935 457.254 767.8 450.119 758.998 450.119Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M384.06 489.4H295.863V491.4H384.06V489.4Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M426.916 478.351H231.568V480.351H426.916V478.351Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M446.715 489.4H416.788V491.4H446.715V489.4Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M279.866 489.4H262.133V491.4H279.866V489.4Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M748.005 460.852H696.237V462.852H748.005V460.852Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M338.024 467.202H303.789V469.202H338.024V467.202Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M352.138 467.202H341.729V469.202H352.138V467.202Z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M631.821 476.926H601.669V478.926H631.821V476.926Z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M653.241 476.926H643.01V478.926H653.241V476.926Z",
    fill: "url(#paint10_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M596.2 476.926H590.137V478.926H596.2V476.926Z",
    fill: "url(#paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M517.029 475.926H498.787V477.926H517.029V475.926Z",
    fill: "url(#paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M533.56 475.926H525.664V477.926H533.56V475.926Z",
    fill: "url(#paint13_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M732.422 476.926H680.569V478.926H732.422V476.926Z",
    fill: "url(#paint14_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M475.613 179.065H471.947L470.49 175.274H463.819L462.442 179.065H458.868L465.368 162.377H468.931L475.613 179.065ZM469.409 172.462L467.11 166.27L464.857 172.462H469.409Z",
    fill: "#032895"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M477.24 179.065V162.377H480.439V168.387C481.425 167.264 482.594 166.703 483.945 166.703C485.417 166.703 486.635 167.236 487.599 168.303C488.562 169.368 489.044 170.899 489.044 172.895C489.044 174.959 488.553 176.549 487.57 177.665C486.587 178.78 485.394 179.339 483.99 179.339C483.3 179.339 482.618 179.166 481.947 178.82C481.275 178.475 480.697 177.966 480.211 177.29V179.065H477.24ZM480.416 172.758C480.416 174.01 480.614 174.936 481.008 175.535C481.562 176.386 482.298 176.81 483.216 176.81C483.922 176.81 484.523 176.508 485.02 175.905C485.517 175.302 485.766 174.351 485.766 173.053C485.766 171.673 485.516 170.676 485.015 170.066C484.515 169.455 483.873 169.15 483.091 169.15C482.324 169.15 481.687 169.447 481.179 170.043C480.67 170.64 480.416 171.545 480.416 172.758Z",
    fill: "#032895"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M502.156 170.551L499.003 171.119C498.897 170.489 498.656 170.015 498.28 169.696C497.904 169.378 497.417 169.218 496.817 169.218C496.02 169.218 495.384 169.492 494.91 170.042C494.436 170.593 494.199 171.513 494.199 172.803C494.199 174.238 494.44 175.251 494.922 175.842C495.404 176.434 496.05 176.73 496.863 176.73C497.47 176.73 497.967 176.558 498.354 176.212C498.741 175.866 499.014 175.273 499.174 174.431L502.315 174.966C501.989 176.407 501.363 177.497 500.437 178.233C499.511 178.968 498.27 179.337 496.715 179.337C494.947 179.337 493.538 178.778 492.486 177.663C491.435 176.548 490.91 175.003 490.91 173.03C490.91 171.034 491.437 169.481 492.492 168.369C493.547 167.258 494.973 166.702 496.772 166.702C498.244 166.702 499.415 167.018 500.284 167.652C501.153 168.287 501.777 169.252 502.156 170.551Z",
    fill: "#032895"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M182.981 297.571C182.272 297.786 181.726 298.079 181.354 298.441C180.979 298.816 180.728 299.299 180.585 299.909C180.442 300.514 180.373 301.575 180.373 303.112C180.373 304.051 180.342 304.708 180.272 305.094C180.192 305.598 180.049 306.012 179.837 306.357C179.625 306.691 179.371 306.923 179.079 307.073C178.787 307.216 178.352 307.296 177.775 307.338V310.179C178.502 310.218 179.038 310.37 179.392 310.654C179.747 310.927 180.008 311.373 180.182 312.009C180.304 312.444 180.373 313.383 180.373 314.837C180.373 316.093 180.433 317.011 180.575 317.588C180.707 318.173 180.971 318.659 181.365 319.052C181.758 319.448 182.234 319.731 182.801 319.902C183.375 320.076 184.196 320.166 185.267 320.166H185.893V317.314C185.044 317.314 184.488 317.265 184.234 317.154C183.983 317.043 183.789 316.889 183.66 316.677C183.538 316.476 183.476 316.113 183.476 315.595C183.476 315.234 183.448 314.392 183.375 313.08C183.336 312.21 183.225 311.522 183.072 311.007C182.912 310.492 182.689 310.058 182.384 309.693C182.092 309.339 181.708 309.025 181.243 308.754C181.768 308.41 182.161 308.086 182.425 307.764C182.678 307.451 182.891 307.057 183.051 306.571C183.214 306.077 183.325 305.448 183.364 304.661C183.437 303.277 183.475 302.335 183.475 301.831C183.475 301.347 183.538 301.003 183.648 300.8C183.77 300.597 183.951 300.446 184.205 300.345C184.445 300.244 185.012 300.193 185.892 300.193V297.363H185.266C184.223 297.36 183.465 297.432 182.981 297.571Z",
    fill: "url(#paint15_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M204.857 310.178V307.337C204.13 307.295 203.592 307.135 203.24 306.861C202.886 306.589 202.624 306.132 202.44 305.507C202.318 305.062 202.259 304.122 202.259 302.675C202.259 301.423 202.196 300.513 202.057 299.938C201.914 299.351 201.651 298.857 201.268 298.46C200.885 298.066 200.398 297.784 199.831 297.611C199.257 297.45 198.436 297.358 197.375 297.358H196.738V300.188C197.638 300.188 198.213 300.251 198.467 300.351C198.731 300.462 198.912 300.612 199.003 300.803C199.104 301.008 199.155 301.402 199.166 301.989C199.205 303.878 199.277 305.093 199.357 305.648C199.489 306.445 199.751 307.113 200.115 307.638C200.387 308.002 200.811 308.366 201.399 308.75C200.943 309.002 200.579 309.307 200.286 309.658C199.994 309.992 199.771 310.417 199.6 310.914C199.426 311.408 199.315 312.064 199.276 312.883C199.214 314.249 199.173 315.168 199.173 315.654C199.165 316.138 199.103 316.482 198.981 316.684C198.859 316.885 198.668 317.038 198.407 317.15C198.143 317.252 197.586 317.299 196.738 317.299V320.152H197.375C198.408 320.152 199.174 320.082 199.649 319.939C200.366 319.727 200.922 319.435 201.297 319.07C201.67 318.705 201.923 318.211 202.055 317.605C202.195 316.987 202.267 315.916 202.267 314.388C202.267 313.449 202.295 312.792 202.368 312.419C202.449 311.911 202.601 311.487 202.813 311.153C203.015 310.822 203.269 310.579 203.561 310.436C203.853 310.293 204.278 310.204 204.865 310.174H204.857V310.178Z",
    fill: "url(#paint16_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M196.135 303.88H186.489V306.438H196.135V303.88Z",
    fill: "url(#paint17_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M196.135 307.477H186.489V310.036H196.135V307.477Z",
    fill: "url(#paint18_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M192.085 311.074H186.489V313.633H192.085V311.074Z",
    fill: "url(#paint19_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M430.67 169.237H371.297V190.604H430.67V169.237Z",
    fill: "url(#paint20_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M431.17 191.104H370.797V168.736H431.17V191.104ZM371.797 190.104H430.17V169.736H371.797V190.104Z",
    fill: "url(#paint21_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M383.459 174.813V178.598H387.834V174.813H389.015V183.858H387.834V179.618H383.459V183.858H382.291V174.813H383.459Z",
    fill: "#02247D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M392.758 175.806H390.008V174.813H396.704V175.806H393.94V183.858H392.758V175.806Z",
    fill: "#02247D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M405.332 179.885C405.265 178.623 405.185 177.108 405.198 175.981H405.157C404.848 177.042 404.472 178.169 404.016 179.417L402.419 183.806H401.533L400.071 179.497C399.641 178.222 399.279 177.055 399.024 175.981H398.998C398.971 177.108 398.904 178.624 398.824 179.979L398.582 183.858H397.468L398.098 174.813H399.589L401.132 179.188C401.507 180.301 401.816 181.295 402.044 182.235H402.085C402.313 181.323 402.635 180.329 403.038 179.188L404.648 174.813H406.138L406.701 183.858H405.56L405.332 179.885Z",
    fill: "#02247D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M408.497 174.813H409.665V182.879H413.53V183.858H408.497V174.813Z",
    fill: "#02247D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M419.622 176.127H416.293L415.958 178.369C416.159 178.342 416.347 178.315 416.669 178.315C417.34 178.315 418.011 178.462 418.548 178.785C419.233 179.174 419.796 179.926 419.796 181.026C419.796 182.73 418.441 184.005 416.548 184.005C415.595 184.005 414.79 183.736 414.374 183.468L414.67 182.57C415.032 182.784 415.744 183.052 416.535 183.052C417.649 183.052 418.602 182.327 418.602 181.159C418.588 180.032 417.837 179.227 416.092 179.227C415.595 179.227 415.206 179.28 414.884 179.321L415.448 175.133H419.621V176.127H419.622Z",
    fill: "#02247D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M235.725 231.29H192.517C189.49 231.29 187.035 233.744 187.035 236.771V260.861C187.035 263.888 189.49 266.341 192.517 266.341H215.714V279.843L228.949 266.341H235.725C238.752 266.341 241.206 263.888 241.206 260.861V236.771C241.206 233.744 238.752 231.29 235.725 231.29Z",
    fill: "#02247D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M215.714 280.844C215.587 280.844 215.458 280.82 215.336 280.77C214.96 280.617 214.714 280.25 214.714 279.844V267.343H192.517C188.943 267.343 186.035 264.435 186.035 260.861V236.772C186.035 233.198 188.943 230.291 192.517 230.291H235.725C239.299 230.291 242.206 233.198 242.206 236.772V260.861C242.206 264.435 239.298 267.343 235.725 267.343H229.37L216.428 280.544C216.236 280.74 215.977 280.844 215.714 280.844ZM192.516 232.29C190.045 232.29 188.034 234.301 188.034 236.771V260.86C188.034 263.332 190.045 265.342 192.516 265.342H215.713C216.265 265.342 216.713 265.789 216.713 266.342V277.395L228.235 265.642C228.423 265.451 228.68 265.342 228.949 265.342H235.724C238.195 265.342 240.205 263.331 240.205 260.86V236.771C240.205 234.3 238.195 232.29 235.724 232.29H192.516Z",
    fill: "url(#paint22_linear)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M203.419 255.09L197.155 248.826C196.798 248.469 196.798 247.887 197.155 247.528L203.245 241.438L204.544 242.736L199.103 248.177L204.718 253.792L203.419 255.09Z",
    fill: "#02247D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M203.419 256.09C203.163 256.09 202.907 255.992 202.712 255.797L196.448 249.533C195.702 248.785 195.702 247.569 196.447 246.822L202.538 240.731C202.929 240.34 203.561 240.34 203.952 240.731L205.251 242.03C205.439 242.218 205.544 242.471 205.544 242.737C205.544 243.003 205.439 243.257 205.251 243.444L200.517 248.177L205.425 253.085C205.613 253.273 205.718 253.527 205.718 253.792C205.718 254.058 205.613 254.312 205.425 254.499L204.127 255.796C203.931 255.992 203.675 256.09 203.419 256.09Z",
    fill: "url(#paint23_linear)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M225.53 255.398L224.233 254.1L229.981 248.352L224.232 242.603L225.53 241.305L231.927 247.703C232.099 247.875 232.195 248.108 232.195 248.351C232.195 248.595 232.099 248.828 231.926 249L225.53 255.398Z",
    fill: "#02247D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M225.53 256.398C225.265 256.398 225.01 256.293 224.823 256.105L223.526 254.807C223.135 254.416 223.135 253.784 223.526 253.393L228.567 248.352L223.525 243.31C223.337 243.122 223.232 242.868 223.232 242.603C223.232 242.337 223.337 242.083 223.525 241.896L224.823 240.598C225.214 240.207 225.846 240.207 226.237 240.598L232.634 246.996C232.996 247.357 233.195 247.839 233.195 248.351C233.195 248.863 232.996 249.344 232.634 249.706L226.236 256.103C226.049 256.292 225.795 256.398 225.53 256.398Z",
    fill: "url(#paint24_linear)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M220.728 237.511L219.051 236.766L209.16 259.03L210.837 259.775L220.728 237.511Z",
    fill: "#02247D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M210.833 260.768C210.697 260.768 210.56 260.741 210.427 260.682L208.75 259.937C208.508 259.829 208.318 259.629 208.223 259.382C208.128 259.134 208.135 258.859 208.243 258.616L218.138 236.355C218.363 235.85 218.955 235.624 219.457 235.847L221.134 236.592C221.377 236.699 221.566 236.9 221.661 237.147C221.756 237.395 221.749 237.67 221.641 237.913L211.746 260.174C211.582 260.547 211.216 260.768 210.833 260.768Z",
    fill: "url(#paint25_linear)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M211.37 200.138C207.187 200.138 203.258 198.625 200.305 195.878C198.389 194.099 195.833 193.118 193.107 193.118C190.381 193.118 187.826 194.098 185.911 195.878C184.804 196.904 182.921 196.834 181.893 195.732C180.828 194.583 180.893 192.781 182.039 191.714C184.996 188.967 188.926 187.454 193.106 187.454C197.286 187.454 201.218 188.967 204.174 191.714C206.089 193.493 208.645 194.474 211.37 194.474C214.097 194.474 216.653 193.494 218.569 191.714C221.524 188.967 225.454 187.455 229.634 187.455C233.814 187.455 237.745 188.967 240.701 191.714C242.615 193.493 245.171 194.474 247.896 194.474C250.623 194.474 253.18 193.494 255.096 191.714C258.05 188.967 261.979 187.454 266.16 187.454C270.341 187.454 274.271 188.967 277.226 191.714C278.373 192.781 278.439 194.583 277.372 195.731C276.343 196.837 274.459 196.904 273.355 195.877C271.44 194.098 268.884 193.117 266.158 193.117C263.432 193.117 260.878 194.096 258.964 195.877C256.007 198.623 252.076 200.136 247.895 200.136C243.714 200.136 239.785 198.624 236.831 195.877C234.915 194.098 232.359 193.117 229.634 193.117C226.907 193.117 224.352 194.097 222.437 195.877C219.48 198.625 215.55 200.138 211.37 200.138ZM193.106 191.118C196.339 191.118 199.378 192.288 201.666 194.413C204.249 196.815 207.695 198.138 211.37 198.138C215.044 198.138 218.491 196.815 221.077 194.413C223.363 192.288 226.403 191.118 229.636 191.118C232.869 191.118 235.907 192.288 238.195 194.413C240.778 196.814 244.224 198.137 247.897 198.137C251.573 198.137 255.021 196.815 257.606 194.413C259.89 192.288 262.929 191.118 266.162 191.118C269.395 191.118 272.435 192.288 274.721 194.413C275.051 194.721 275.605 194.7 275.912 194.369C276.227 194.03 276.208 193.496 275.867 193.18C273.284 190.779 269.838 189.455 266.163 189.455C262.489 189.455 259.043 190.778 256.46 193.18C254.172 195.305 251.132 196.475 247.898 196.475C244.666 196.475 241.627 195.305 239.341 193.18C236.756 190.779 233.309 189.456 229.635 189.456C225.961 189.456 222.515 190.778 219.931 193.18C217.644 195.305 214.604 196.475 211.37 196.475C208.138 196.475 205.099 195.305 202.812 193.18C200.227 190.779 196.78 189.455 193.105 189.455C189.431 189.455 185.985 190.778 183.4 193.18C183.061 193.495 183.042 194.031 183.358 194.37C183.661 194.696 184.218 194.719 184.549 194.412C186.835 192.288 189.874 191.118 193.106 191.118Z",
    fill: "url(#paint26_linear)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M634.582 322.174C630.398 322.174 626.469 320.66 623.517 317.914C621.601 316.135 619.045 315.154 616.319 315.154C613.593 315.154 611.038 316.134 609.123 317.914C608.015 318.94 606.132 318.869 605.105 317.768C604.04 316.62 604.105 314.818 605.251 313.75C608.208 311.004 612.138 309.49 616.318 309.49C620.498 309.49 624.43 311.004 627.385 313.75C629.301 315.529 631.856 316.51 634.582 316.51C637.308 316.51 639.865 315.53 641.781 313.75C644.736 311.004 648.666 309.492 652.845 309.492C657.027 309.492 660.957 311.004 663.913 313.75C665.827 315.529 668.383 316.51 671.107 316.51C673.835 316.51 676.391 315.53 678.307 313.75C681.261 311.004 685.191 309.49 689.372 309.49C693.553 309.49 697.482 311.004 700.437 313.75C701.585 314.818 701.65 316.619 700.583 317.768C699.554 318.873 697.671 318.941 696.567 317.914C694.651 316.135 692.096 315.154 689.37 315.154C686.644 315.154 684.089 316.133 682.175 317.914C679.218 320.66 675.288 322.172 671.106 322.172C666.925 322.172 662.997 320.66 660.043 317.914C658.127 316.135 655.57 315.154 652.846 315.154C650.119 315.154 647.563 316.134 645.649 317.914C642.693 320.66 638.762 322.174 634.582 322.174ZM616.319 313.155C619.551 313.155 622.59 314.325 624.878 316.45C627.462 318.852 630.907 320.175 634.583 320.175C638.257 320.175 641.704 318.851 644.29 316.45C646.576 314.325 649.616 313.155 652.849 313.155C656.082 313.155 659.12 314.325 661.408 316.45C663.99 318.85 667.437 320.173 671.11 320.173C674.785 320.173 678.234 318.851 680.819 316.45C683.103 314.325 686.142 313.155 689.375 313.155C692.608 313.155 695.648 314.325 697.934 316.45C698.264 316.757 698.817 316.737 699.125 316.405C699.439 316.067 699.42 315.532 699.08 315.216C696.496 312.816 693.051 311.491 689.376 311.491C685.702 311.491 682.256 312.815 679.673 315.216C677.385 317.341 674.344 318.511 671.11 318.511C667.879 318.511 664.839 317.341 662.554 315.216C659.968 312.816 656.522 311.493 652.847 311.493C649.173 311.493 645.728 312.815 643.144 315.216C640.856 317.341 637.816 318.511 634.583 318.511C631.35 318.511 628.312 317.341 626.024 315.216C623.44 312.816 619.993 311.491 616.318 311.491C612.643 311.491 609.198 312.815 606.613 315.216C606.274 315.532 606.255 316.068 606.571 316.407C606.874 316.733 607.43 316.755 607.762 316.448C610.046 314.324 613.086 313.155 616.319 313.155Z",
    fill: "url(#paint27_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M633.438 230.525L621.864 230.498L621.728 289.675L633.302 289.702L633.438 230.525Z",
    fill: "#02247D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M633.307 290.689C633.306 290.689 633.305 290.689 633.305 290.689L621.731 290.663C621.178 290.662 620.732 290.213 620.733 289.661L620.866 230.484C620.867 230.218 620.972 229.964 621.161 229.777C621.348 229.59 621.601 229.486 621.866 229.486C621.867 229.486 621.868 229.486 621.868 229.486L633.442 229.512C633.995 229.513 634.441 229.962 634.44 230.514L634.307 289.691C634.306 289.957 634.201 290.211 634.012 290.398C633.825 290.584 633.571 290.689 633.307 290.689ZM622.735 288.664L632.309 288.686L632.438 231.509L622.864 231.487L622.735 288.664Z",
    fill: "url(#paint28_linear)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M633.321 281.494L621.747 281.467L621.743 283.195L633.317 283.222L633.321 281.494Z",
    fill: "#02247D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M633.321 284.208C633.32 284.208 633.319 284.208 633.319 284.208L621.745 284.182C621.192 284.181 620.746 283.732 620.747 283.18L620.751 281.452C620.752 280.9 621.2 280.454 621.751 280.454C621.752 280.454 621.752 280.454 621.753 280.454L633.327 280.479C633.593 280.48 633.847 280.585 634.034 280.774C634.221 280.962 634.326 281.216 634.325 281.481L634.321 283.21C634.32 283.476 634.215 283.73 634.026 283.918C633.84 284.104 633.586 284.208 633.321 284.208Z",
    fill: "url(#paint29_linear)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M633.347 275.505L621.772 275.479L621.768 277.207L633.343 277.233L633.347 275.505Z",
    fill: "#02247D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M633.343 278.229C633.342 278.229 633.341 278.229 633.341 278.229L621.766 278.203C621.213 278.202 620.767 277.753 620.768 277.201L620.772 275.472C620.773 275.206 620.878 274.952 621.067 274.765C621.254 274.578 621.507 274.474 621.772 274.474C621.773 274.474 621.774 274.474 621.774 274.474L633.349 274.5C633.902 274.501 634.348 274.95 634.347 275.502L634.343 277.231C634.342 277.497 634.237 277.751 634.048 277.938C633.862 278.124 633.608 278.229 633.343 278.229Z",
    fill: "url(#paint30_linear)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M633.347 290.057L640.555 290.073V251.36L633.347 251.344V290.057Z",
    fill: "#02247D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M640.555 291.073C640.554 291.073 640.553 291.073 640.553 291.073L633.345 291.056C632.793 291.055 632.347 290.608 632.347 290.056V251.344C632.347 251.078 632.452 250.823 632.641 250.636C632.829 250.449 633.082 250.344 633.347 250.344C633.348 250.344 633.349 250.344 633.349 250.344L640.557 250.361C641.109 250.362 641.555 250.809 641.555 251.361V290.073C641.555 290.339 641.45 290.594 641.261 290.781C641.073 290.967 640.82 291.073 640.555 291.073ZM634.347 289.058L639.555 289.071V252.359L634.347 252.346V289.058Z",
    fill: "url(#paint31_linear)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M696.762 296.576H611.959C610.198 296.576 608.771 295.149 608.771 293.388C608.771 291.627 610.199 290.2 611.959 290.2H696.762C698.523 290.2 699.95 291.627 699.95 293.388C699.949 295.15 698.523 296.576 696.762 296.576Z",
    fill: "#02247D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M696.762 297.576H611.959C609.649 297.576 607.771 295.697 607.771 293.388C607.771 291.078 609.65 289.2 611.959 289.2H696.762C699.071 289.2 700.95 291.079 700.95 293.388C700.949 295.698 699.071 297.576 696.762 297.576ZM611.959 291.2C610.752 291.2 609.771 292.181 609.771 293.388C609.771 294.594 610.752 295.576 611.959 295.576H696.762C697.968 295.576 698.95 294.595 698.95 293.388C698.95 292.181 697.969 291.2 696.762 291.2H611.959Z",
    fill: "url(#paint32_linear)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M362.828 184.119H322.828V186.119H362.828V184.119Z",
    fill: "url(#paint33_linear)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M666.25 270.037H643.887V272.037H666.25V270.037Z",
    fill: "url(#paint34_linear)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M264.964 215.44H242.601V217.44H264.964V215.44Z",
    fill: "url(#paint35_linear)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M611.554 223.711H601.414V225.711H611.554V223.711Z",
    fill: "url(#paint36_linear)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M688.876 358.272C686.984 358.272 685.445 356.733 685.445 354.842C685.445 352.949 686.984 351.41 688.876 351.41C690.768 351.41 692.307 352.949 692.307 354.842C692.307 356.733 690.768 358.272 688.876 358.272ZM688.876 353.41C688.087 353.41 687.445 354.053 687.445 354.842C687.445 355.631 688.087 356.272 688.876 356.272C689.665 356.272 690.307 355.631 690.307 354.842C690.307 354.053 689.665 353.41 688.876 353.41Z",
    fill: "url(#paint37_linear)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M552.547 304.116C550.655 304.116 549.117 302.578 549.117 300.685C549.117 298.794 550.655 297.255 552.547 297.255C554.439 297.255 555.978 298.794 555.978 300.685C555.978 302.578 554.439 304.116 552.547 304.116ZM552.547 299.256C551.759 299.256 551.117 299.898 551.117 300.686C551.117 301.475 551.759 302.117 552.547 302.117C553.336 302.117 553.978 301.475 553.978 300.686C553.978 299.898 553.336 299.256 552.547 299.256Z",
    fill: "url(#paint38_linear)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M246.117 183.895C244.225 183.895 242.687 182.357 242.687 180.465C242.687 178.573 244.226 177.033 246.117 177.033C248.008 177.033 249.548 178.573 249.548 180.465C249.548 182.357 248.009 183.895 246.117 183.895ZM246.117 179.033C245.328 179.033 244.687 179.676 244.687 180.465C244.687 181.254 245.329 181.895 246.117 181.895C246.906 181.895 247.548 181.254 247.548 180.465C247.548 179.676 246.906 179.033 246.117 179.033Z",
    fill: "url(#paint39_linear)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M227.231 223.301C225.339 223.301 223.801 221.762 223.801 219.871C223.801 217.978 225.34 216.439 227.231 216.439C229.122 216.439 230.662 217.978 230.662 219.871C230.661 221.762 229.122 223.301 227.231 223.301ZM227.231 218.44C226.442 218.44 225.801 219.083 225.801 219.872C225.801 220.66 226.443 221.302 227.231 221.302C228.02 221.302 228.662 220.66 228.662 219.872C228.661 219.082 228.02 218.44 227.231 218.44Z",
    fill: "url(#paint40_linear)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M291.494 190.754L290.08 189.34L294.096 185.324L295.51 186.739L291.494 190.754Z",
    fill: "url(#paint41_linear)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M294.096 190.754L290.08 186.739L291.494 185.324L295.51 189.34L294.096 190.754Z",
    fill: "url(#paint42_linear)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M695.678 324.016H673.315V326.016H695.678V324.016Z",
    fill: "url(#paint43_linear)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M595.671 254.059L594.257 252.645L598.273 248.629L599.687 250.043L595.671 254.059Z",
    fill: "url(#paint44_linear)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M598.273 254.059L594.257 250.043L595.671 248.629L599.687 252.645L598.273 254.059Z",
    fill: "url(#paint45_linear)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M710.307 334.636H670.307V336.636H710.307V334.636Z",
    fill: "url(#paint46_linear)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M636.623 203.283H596.623V205.283H636.623V203.283Z",
    fill: "url(#paint47_linear)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M531.367 188.039H502.315V190.039H531.367V188.039Z",
    fill: "url(#paint48_linear)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M499.288 188.039H491.366V190.039H499.288V188.039Z",
    fill: "url(#paint49_linear)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M357.35 172.02H334.987V174.02H357.35V172.02Z",
    fill: "url(#paint50_linear)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M549.555 166.366H539.415V168.366H549.555V166.366Z",
    fill: "url(#paint51_linear)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M523.988 174.152C522.096 174.152 520.557 172.613 520.557 170.721C520.557 168.829 522.096 167.291 523.988 167.291C525.879 167.291 527.418 168.829 527.418 170.721C527.418 172.613 525.879 174.152 523.988 174.152ZM523.988 169.291C523.199 169.291 522.557 169.932 522.557 170.721C522.557 171.51 523.199 172.152 523.988 172.152C524.777 172.152 525.418 171.51 525.418 170.721C525.418 169.932 524.777 169.291 523.988 169.291Z",
    fill: "url(#paint52_linear)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M331.512 206.283C329.62 206.283 328.082 204.744 328.082 202.851C328.082 200.96 329.62 199.421 331.512 199.421C333.404 199.421 334.943 200.96 334.943 202.851C334.943 204.744 333.404 206.283 331.512 206.283ZM331.512 201.422C330.724 201.422 330.082 202.064 330.082 202.852C330.082 203.641 330.724 204.284 331.512 204.284C332.302 204.284 332.943 203.641 332.943 202.852C332.943 202.064 332.301 201.422 331.512 201.422Z",
    fill: "url(#paint53_linear)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M255.196 265.557L253.782 264.143L257.798 260.126L259.212 261.54L255.196 265.557Z",
    fill: "url(#paint54_linear)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M255.196 265.557L253.782 264.143L257.798 260.126L259.212 261.54L255.196 265.557Z",
    fill: "url(#paint55_linear)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M257.798 265.557L253.782 261.54L255.196 260.126L259.212 264.143L257.798 265.557Z",
    fill: "url(#paint56_linear)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M237.306 149.431L235.892 148.017L239.907 144L241.321 145.414L237.306 149.431Z",
    fill: "url(#paint57_linear)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M237.306 149.431L235.892 148.017L239.907 144L241.321 145.414L237.306 149.431Z",
    fill: "url(#paint58_linear)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M239.907 149.431L235.892 145.414L237.306 144L241.321 148.017L239.907 149.431Z",
    fill: "url(#paint59_linear)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M432.286 197.137H403.234V199.137H432.286V197.137Z",
    fill: "url(#paint60_linear)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M400.207 197.137H392.286V199.137H400.207V197.137Z",
    fill: "url(#paint61_linear)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M262.06 285.021H233.008V287.021H262.06V285.021Z",
    fill: "url(#paint62_linear)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M229.981 285.021H222.06V287.021H229.981V285.021Z",
    fill: "url(#paint63_linear)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M211.985 209.539H189.622V211.539H211.985V209.539Z",
    fill: "url(#paint64_linear)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M268.308 164.408H239.256V166.408H268.308V164.408Z",
    fill: "url(#paint65_linear)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M236.229 164.408H228.308V166.408H236.229V164.408Z",
    fill: "url(#paint66_linear)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M380.99 159.3L379.576 157.886L383.592 153.869L385.006 155.283L380.99 159.3Z",
    fill: "url(#paint67_linear)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M380.99 159.3L379.576 157.886L383.592 153.869L385.006 155.283L380.99 159.3Z",
    fill: "url(#paint68_linear)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M383.592 159.3L379.576 155.283L380.99 153.869L385.006 157.886L383.592 159.3Z",
    fill: "url(#paint69_linear)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M456.253 190.549L454.839 189.135L458.854 185.119L460.268 186.533L456.253 190.549Z",
    fill: "url(#paint70_linear)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M456.253 190.549L454.839 189.135L458.854 185.119L460.268 186.533L456.253 190.549Z",
    fill: "url(#paint71_linear)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M458.854 190.549L454.839 186.533L456.253 185.119L460.268 189.135L458.854 190.549Z",
    fill: "url(#paint72_linear)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M444.365 156.585H415.313V158.585H444.365V156.585Z",
    fill: "url(#paint73_linear)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M412.286 156.585H404.365V158.585H412.286V156.585Z",
    fill: "url(#paint74_linear)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M648.657 217.181L647.243 215.767L651.259 211.75L652.673 213.164L648.657 217.181Z",
    fill: "url(#paint75_linear)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M648.657 217.181L647.243 215.767L651.259 211.75L652.673 213.164L648.657 217.181Z",
    fill: "url(#paint76_linear)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M651.259 217.181L647.243 213.164L648.657 211.75L652.673 215.767L651.259 217.181Z",
    fill: "url(#paint77_linear)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M688.345 307.36L686.931 305.946L690.946 301.93L692.361 303.344L688.345 307.36Z",
    fill: "url(#paint78_linear)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M690.946 307.36L686.931 303.344L688.345 301.93L692.361 305.946L690.946 307.36Z",
    fill: "url(#paint79_linear)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M625.918 354.389H523.242C519.094 354.389 515.731 351.026 515.731 346.877C515.731 342.729 519.094 339.365 523.242 339.365H625.918C630.066 339.365 633.43 342.728 633.43 346.877C633.43 351.026 630.067 354.389 625.918 354.389Z",
    fill: "url(#paint80_linear)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M625.918 355.389H523.242C518.549 355.389 514.731 351.571 514.731 346.877C514.731 342.183 518.549 338.365 523.242 338.365H625.918C630.611 338.365 634.43 342.183 634.43 346.877C634.43 351.571 630.612 355.389 625.918 355.389ZM523.242 340.365C519.652 340.365 516.731 343.286 516.731 346.877C516.731 350.468 519.652 353.389 523.242 353.389H625.918C629.509 353.389 632.43 350.468 632.43 346.877C632.43 343.286 629.509 340.365 625.918 340.365H523.242Z",
    fill: "url(#paint81_linear)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M544.741 354.389H191.461C187.313 354.389 183.95 351.026 183.95 346.877C183.95 342.729 187.313 339.365 191.461 339.365H544.741C548.889 339.365 552.252 342.728 552.252 346.877C552.252 351.026 548.89 354.389 544.741 354.389Z",
    fill: "#02247D"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M544.741 355.389H191.461C186.768 355.389 182.95 351.571 182.95 346.877C182.95 342.185 186.768 338.366 191.461 338.366H544.741C549.433 338.366 553.252 342.184 553.252 346.877C553.252 351.571 549.434 355.389 544.741 355.389ZM191.461 340.366C187.871 340.366 184.95 343.287 184.95 346.877C184.95 350.468 187.871 353.389 191.461 353.389H544.741C548.331 353.389 551.252 350.468 551.252 346.877C551.252 343.287 548.331 340.366 544.741 340.366H191.461Z",
    fill: "url(#paint82_linear)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M221.983 354.389H204.757V472.502H221.983V354.389Z",
    fill: "#02247D"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M221.983 473.503H204.757C204.205 473.503 203.757 473.056 203.757 472.503V354.389C203.757 353.836 204.205 353.389 204.757 353.389H221.983C222.535 353.389 222.983 353.836 222.983 354.389V472.503C222.983 473.056 222.535 473.503 221.983 473.503ZM205.757 471.503H220.983V355.389H205.757V471.503Z",
    fill: "url(#paint83_linear)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M213.37 354.389H196.144V472.502H213.37V354.389Z",
    fill: "#02247D"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M213.37 473.503H196.144C195.592 473.503 195.144 473.056 195.144 472.503V354.389C195.144 353.836 195.592 353.389 196.144 353.389H213.37C213.922 353.389 214.37 353.836 214.37 354.389V472.503C214.37 473.056 213.922 473.503 213.37 473.503ZM197.144 471.503H212.37V355.389H197.144V471.503Z",
    fill: "url(#paint84_linear)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M619.003 354.389H539.862V472.502H619.003V354.389Z",
    fill: "url(#paint85_linear)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M620.002 473.503H538.861V353.389H620.002V473.503ZM540.862 471.503H618.003V355.389H540.862V471.503Z",
    fill: "url(#paint86_linear)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M447.484 354.389H428.022V472.502H447.484V354.389Z",
    fill: "#02247D"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M447.484 473.503H428.022C427.47 473.503 427.022 473.056 427.022 472.503V354.389C427.022 353.836 427.47 353.389 428.022 353.389H447.484C448.036 353.389 448.484 353.836 448.484 354.389V472.503C448.484 473.056 448.036 473.503 447.484 473.503ZM429.022 471.503H446.484V355.389H429.022V471.503Z",
    fill: "url(#paint87_linear)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M522.636 354.389H447.484V472.502H522.636V354.389Z",
    fill: "#02247D"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M522.636 473.503H447.484C446.932 473.503 446.484 473.056 446.484 472.503V354.389C446.484 353.836 446.932 353.389 447.484 353.389H522.636C523.188 353.389 523.636 353.836 523.636 354.389V472.503C523.636 473.056 523.188 473.503 522.636 473.503ZM448.484 471.503H521.636V355.389H448.484V471.503Z",
    fill: "url(#paint88_linear)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M522.636 386.582H447.484V388.582H522.636V386.582Z",
    fill: "url(#paint89_linear)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M522.636 415.332H447.484V417.332H522.636V415.332Z",
    fill: "url(#paint90_linear)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M483.643 404.421C485.328 404.421 486.694 403.055 486.694 401.37C486.694 399.685 485.328 398.319 483.643 398.319C481.958 398.319 480.592 399.685 480.592 401.37C480.592 403.055 481.958 404.421 483.643 404.421Z",
    fill: "#02247D"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M483.643 405.421C481.409 405.421 479.592 403.604 479.592 401.37C479.592 399.136 481.409 397.319 483.643 397.319C485.877 397.319 487.694 399.136 487.694 401.37C487.694 403.604 485.877 405.421 483.643 405.421ZM483.643 399.32C482.512 399.32 481.592 400.24 481.592 401.371C481.592 402.502 482.512 403.422 483.643 403.422C484.774 403.422 485.694 402.502 485.694 401.371C485.694 400.24 484.774 399.32 483.643 399.32Z",
    fill: "url(#paint91_linear)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M483.643 373.151C485.328 373.151 486.694 371.785 486.694 370.1C486.694 368.415 485.328 367.049 483.643 367.049C481.958 367.049 480.592 368.415 480.592 370.1C480.592 371.785 481.958 373.151 483.643 373.151Z",
    fill: "#02247D"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M483.643 374.151C481.409 374.151 479.592 372.334 479.592 370.1C479.592 367.866 481.409 366.048 483.643 366.048C485.877 366.048 487.694 367.865 487.694 370.1C487.695 372.333 485.877 374.151 483.643 374.151ZM483.643 368.048C482.512 368.048 481.592 368.969 481.592 370.1C481.592 371.231 482.512 372.151 483.643 372.151C484.774 372.151 485.694 371.231 485.694 370.1C485.694 368.969 484.774 368.048 483.643 368.048Z",
    fill: "url(#paint92_linear)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M470.258 444.504C470.258 446.826 472.158 448.727 474.481 448.727H495.639C497.962 448.727 499.862 446.827 499.862 444.504C499.862 442.182 497.962 440.281 495.639 440.281H474.481C472.158 440.282 470.258 442.182 470.258 444.504Z",
    fill: "url(#paint93_linear)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M495.639 449.728H474.481C471.601 449.728 469.258 447.384 469.258 444.504C469.258 441.624 471.601 439.28 474.481 439.28H495.639C498.519 439.28 500.862 441.624 500.862 444.504C500.862 447.384 498.519 449.728 495.639 449.728ZM474.481 441.281C472.704 441.281 471.258 442.727 471.258 444.505C471.258 446.283 472.704 447.729 474.481 447.729H495.639C497.416 447.729 498.862 446.283 498.862 444.505C498.862 442.727 497.416 441.281 495.639 441.281H474.481Z",
    fill: "url(#paint94_linear)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M539.862 354.389H522.636V472.502H539.862V354.389Z",
    fill: "#02247D"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M539.862 473.503H522.636C522.084 473.503 521.636 473.056 521.636 472.503V354.389C521.636 353.836 522.084 353.389 522.636 353.389H539.862C540.415 353.389 540.862 353.836 540.862 354.389V472.503C540.862 473.056 540.414 473.503 539.862 473.503ZM523.636 471.503H538.862V355.389H523.636V471.503Z",
    fill: "url(#paint95_linear)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M348.829 366.86C347.862 365.102 346.016 364.009 344.009 364.009H316.803C316.177 368.082 314.657 371.631 312.356 375.009H334.005C334.005 375.009 300.562 419.416 290.593 443.418C289.427 446.223 289.725 449.381 292.29 451.008C293.204 451.588 294.224 451.865 295.231 451.865C297.051 451.865 300.68 450.566 301.728 448.916C313.923 429.703 348.653 372.456 348.653 372.456C349.728 370.762 349.795 368.617 348.829 366.86Z",
    fill: "url(#paint96_linear)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M343.714 329.504C340.2 329.588 339.24 329.45 336.112 329.201C336.732 327.931 339.484 320.521 337.768 318.781C337.164 318.168 336.982 318.457 336.778 318.552C335.959 318.937 333.845 326.375 327.137 329.327L328.576 339.242C331.994 339.274 338.833 340.251 340.347 340.313C350.312 340.729 351.107 340.233 352.954 336.629C355.526 331.619 349.048 329.375 343.714 329.504Z",
    fill: "url(#paint97_linear)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M344.123 358.748C337.813 357.281 327.386 355.846 316.491 354.729C316.933 357.181 317.239 359.654 317.032 362.134C316.562 367.759 314.484 372.364 311.072 376.78C310.291 377.791 309.466 378.751 308.606 379.664C317.542 379.615 324.3 379.575 324.3 379.575C298.3 412.798 291.237 435.632 290.777 436.475C299.084 442.579 308.977 441.952 309.054 441.83C309.054 441.83 338.522 396.033 348.909 379.844C355.107 370.184 350.395 360.208 344.123 358.748Z",
    fill: "#02247D"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M307.702 442.886C304.566 442.886 297.007 442.296 290.183 437.282C289.78 436.986 289.658 436.436 289.898 435.997C289.929 435.926 290.016 435.687 290.154 435.315C296.24 418.93 307.606 399.558 322.246 380.588L308.61 380.665C308.242 380.664 307.847 380.431 307.688 380.063C307.528 379.697 307.603 379.27 307.877 378.979C308.731 378.073 309.54 377.127 310.28 376.169C313.78 371.638 315.609 367.151 316.035 362.051C316.247 359.514 315.887 357.015 315.507 354.905C315.451 354.596 315.545 354.279 315.758 354.049C315.971 353.82 316.279 353.707 316.593 353.734C328.568 354.962 338.426 356.396 344.349 357.774C347.495 358.506 350.248 361.096 351.713 364.704C353.708 369.615 352.992 375.331 349.749 380.385C339.361 396.574 309.893 442.373 309.893 442.373C309.745 442.604 309.459 442.779 309.189 442.83C309.169 442.834 308.629 442.886 307.702 442.886ZM291.991 436.114C298.969 440.912 306.748 440.948 308.475 440.884C311.437 436.28 338.259 394.593 348.067 379.306C350.954 374.806 351.608 369.759 349.861 365.458C348.64 362.452 346.41 360.309 343.897 359.723C338.268 358.414 329 357.049 317.697 355.862C318 357.798 318.216 359.973 318.028 362.219C317.568 367.722 315.609 372.544 311.862 377.394C311.535 377.817 311.195 378.238 310.845 378.654L324.292 378.578C324.294 378.578 324.296 378.578 324.298 378.578C324.679 378.578 325.027 378.795 325.195 379.138C325.364 379.482 325.321 379.893 325.085 380.195C309.958 399.524 298.218 419.347 292.027 436.014C292.015 436.047 292.003 436.08 291.991 436.114Z",
    fill: "url(#paint98_linear)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M324.844 342.339C320.418 343.387 291.348 344.309 279.755 342.178C276.388 341.559 270.055 336.325 269.588 332.934C267.872 320.437 265.499 290.782 270.69 282.621C275.486 275.082 284.878 273.958 285.968 277.9C290.045 292.65 286.411 325.705 286.411 325.705C286.411 325.705 312.808 323.437 325.214 328.026C329.844 329.74 330.041 341.11 324.844 342.339Z",
    fill: "#02247D"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M301.83 344.482C293.452 344.482 284.83 344.128 279.575 343.162C275.691 342.449 269.127 336.911 268.598 333.069C267.058 321.856 264.28 290.837 269.847 282.086C273.365 276.558 279.349 274.194 283.186 274.76C285.143 275.053 286.508 276.101 286.932 277.635C290.621 290.982 288.15 318.457 287.531 324.616C292.91 324.225 314.464 322.983 325.562 327.09C328.706 328.253 329.905 332.576 329.69 336.101C329.456 339.932 327.688 342.696 325.075 343.313V343.314C322.497 343.922 312.357 344.482 301.83 344.482ZM281.943 276.669C278.742 276.669 274.312 278.793 271.535 283.159C266.878 290.479 268.478 317.49 270.58 332.797C270.977 335.688 276.89 340.635 279.936 341.194C291.298 343.284 320.2 342.41 324.614 341.366C326.671 340.879 327.553 338.263 327.693 335.977C327.896 332.65 326.681 329.635 324.867 328.963C312.812 324.504 286.76 326.68 286.497 326.7C286.2 326.732 285.905 326.617 285.696 326.402C285.487 326.188 285.384 325.892 285.417 325.594C285.453 325.266 288.983 292.561 285.004 278.166C284.725 277.154 283.56 276.835 282.89 276.735C282.59 276.693 282.273 276.669 281.943 276.669Z",
    fill: "url(#paint99_linear)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M291.328 443.666C296.411 447.082 303.435 446.248 303.661 446.248C303.661 446.248 319.016 454.369 327.049 454.352C330.476 454.344 331.789 461.834 323.882 461.852C309.318 461.883 298.6 459.273 298.6 459.273L298.044 461.823C298.068 461.823 287.946 461.852 287.946 461.852C287.943 460.247 285.735 455.779 285.727 451.954C285.72 448.686 286.834 440.645 291.328 443.666Z",
    fill: "#02247D"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M323.635 462.852C311.763 462.852 302.355 461.096 299.363 460.466L299.044 461.931C299.037 462.82 298.815 462.821 292.998 462.837L287.949 462.852C287.948 462.852 287.947 462.852 287.946 462.852C287.682 462.852 287.428 462.748 287.24 462.561C287.052 462.373 286.946 462.12 286.946 461.854C286.945 461.377 286.584 460.244 286.235 459.148C285.566 457.046 284.732 454.431 284.727 451.956C284.727 451.638 284.748 444.127 288.059 442.359C288.851 441.934 290.159 441.673 291.886 442.836C295.91 445.541 301.313 445.432 303.451 445.263C303.569 445.252 303.638 445.215 303.666 445.25C303.827 445.251 303.986 445.29 304.129 445.366C304.28 445.446 319.325 453.352 327.023 453.352C327.034 453.353 327.042 453.354 327.054 453.352C329.085 453.352 330.741 455.261 330.745 457.613C330.75 460.023 328.956 462.842 323.885 462.852C323.802 462.852 323.718 462.852 323.635 462.852ZM298.6 458.273C298.679 458.273 298.758 458.283 298.836 458.301C298.941 458.326 309.497 460.852 323.634 460.852C323.717 460.852 323.798 460.852 323.881 460.852C327.472 460.844 328.748 459.175 328.745 457.617C328.743 456.522 328.063 455.352 327.054 455.352C327.05 455.356 327.034 455.352 327.024 455.352C319.307 455.353 305.552 448.36 303.447 447.266C300.93 447.447 295.19 447.465 290.77 444.495C289.679 443.762 289.168 444.034 289 444.122C287.587 444.877 286.72 448.773 286.727 451.951C286.731 454.118 287.513 456.57 288.141 458.54C288.425 459.431 288.671 460.203 288.814 460.849L297.239 460.825L297.624 459.06C297.682 458.796 297.843 458.568 298.071 458.425C298.231 458.324 298.415 458.273 298.6 458.273Z",
    fill: "url(#paint100_linear)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M441.048 338.189H407.681L412.528 307.921H436.202L441.048 338.189Z",
    fill: "#02247D"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M441.048 339.189H407.682C407.389 339.189 407.111 339.061 406.921 338.837C406.731 338.614 406.648 338.319 406.694 338.03L411.54 307.762C411.618 307.277 412.036 306.92 412.527 306.92H436.201C436.692 306.92 437.111 307.276 437.188 307.762L442.034 338.03C442.08 338.319 441.998 338.614 441.807 338.837C441.619 339.061 441.341 339.189 441.048 339.189ZM408.855 337.189H439.876L435.35 308.921H413.381L408.855 337.189Z",
    fill: "url(#paint101_linear)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M461.767 339.368H386.963C385.151 339.368 383.683 337.899 383.683 336.088C383.683 334.276 385.151 332.808 386.963 332.808H461.767C463.579 332.808 465.047 334.277 465.047 336.088C465.047 337.9 463.578 339.368 461.767 339.368Z",
    fill: "#02247D"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M461.767 340.368H386.963C384.603 340.368 382.683 338.448 382.683 336.088C382.683 333.728 384.603 331.808 386.963 331.808H461.767C464.127 331.808 466.047 333.728 466.047 336.088C466.047 338.448 464.127 340.368 461.767 340.368ZM386.963 333.808C385.706 333.808 384.683 334.83 384.683 336.088C384.683 337.346 385.705 338.368 386.963 338.368H461.767C463.024 338.368 464.047 337.346 464.047 336.088C464.047 334.83 463.024 333.808 461.767 333.808H386.963Z",
    fill: "url(#paint102_linear)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M503.517 207.582H345.212C341.558 207.582 338.595 210.545 338.595 214.199V303.247V305.978C338.595 309.631 341.558 312.593 345.212 312.593H503.517C507.171 312.593 510.134 309.631 510.134 305.978V303.247V214.199C510.134 210.545 507.171 207.582 503.517 207.582Z",
    fill: "url(#paint103_linear)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M503.517 313.594H345.212C341.012 313.594 337.595 310.178 337.595 305.979V214.2C337.595 210 341.012 206.583 345.212 206.583H503.517C507.717 206.583 511.134 210 511.134 214.2V305.979C511.134 310.178 507.717 313.594 503.517 313.594ZM345.212 208.582C342.115 208.582 339.595 211.102 339.595 214.199V305.978C339.595 309.075 342.115 311.593 345.212 311.593H503.517C506.614 311.593 509.134 309.074 509.134 305.978V214.199C509.134 211.101 506.614 208.582 503.517 208.582H345.212Z",
    fill: "url(#paint104_linear)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M502.562 214.465H346.169V296.669H502.562V214.465Z",
    fill: "url(#paint105_linear)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M502.561 297.669H346.169C345.617 297.669 345.169 297.222 345.169 296.669V214.466C345.169 213.913 345.617 213.466 346.169 213.466H502.562C503.114 213.466 503.562 213.913 503.562 214.466V296.669C503.561 297.222 503.113 297.669 502.561 297.669ZM347.169 295.669H501.562V215.466H347.169V295.669Z",
    fill: "url(#paint106_linear)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M365.626 214.465H346.169V296.669H365.626V214.465Z",
    fill: "#02247D"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M365.625 297.669H346.168C345.616 297.669 345.168 297.222 345.168 296.669V214.466C345.168 213.913 345.616 213.466 346.168 213.466H365.625C366.177 213.466 366.625 213.913 366.625 214.466V296.669C366.625 297.222 366.177 297.669 365.625 297.669ZM347.169 295.669H364.626V215.466H347.169V295.669Z",
    fill: "url(#paint107_linear)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M502.562 214.465H492.215V296.669H502.562V214.465Z",
    fill: "#02247D"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M502.561 297.669H492.214C491.662 297.669 491.214 297.222 491.214 296.669V214.466C491.214 213.913 491.662 213.466 492.214 213.466H502.561C503.113 213.466 503.561 213.913 503.561 214.466V296.669C503.561 297.222 503.113 297.669 502.561 297.669ZM493.215 295.669H501.562V215.466H493.215V295.669Z",
    fill: "url(#paint108_linear)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M354.423 227.574H348.277V233.144H354.423V227.574Z",
    fill: "url(#paint109_linear)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M363.161 227.574H357.014V233.144H363.161V227.574Z",
    fill: "url(#paint110_linear)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M354.423 235.696H348.277V241.266H354.423V235.696Z",
    fill: "url(#paint111_linear)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M363.161 235.696H357.014V241.266H363.161V235.696Z",
    fill: "url(#paint112_linear)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M354.423 243.816H348.277V249.386H354.423V243.816Z",
    fill: "url(#paint113_linear)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M363.161 243.816H357.014V249.386H363.161V243.816Z",
    fill: "url(#paint114_linear)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M354.423 251.936H348.277V257.506H354.423V251.936Z",
    fill: "url(#paint115_linear)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M363.161 251.936H357.014V257.506H363.161V251.936Z",
    fill: "url(#paint116_linear)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M354.423 260.056H348.277V265.626H354.423V260.056Z",
    fill: "url(#paint117_linear)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M363.161 260.056H357.014V265.626H363.161V260.056Z",
    fill: "url(#paint118_linear)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M354.423 268.176H348.277V273.746H354.423V268.176Z",
    fill: "url(#paint119_linear)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M363.161 268.176H357.014V273.746H363.161V268.176Z",
    fill: "url(#paint120_linear)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M354.423 280.168H348.277V292.272H354.423V280.168Z",
    fill: "url(#paint121_linear)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M363.161 280.168H357.014V292.272H363.161V280.168Z",
    fill: "url(#paint122_linear)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M500.461 284.838H494.314V292.273H500.461V284.838Z",
    fill: "url(#paint123_linear)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M500.461 271.059H494.314V278.494H500.461V271.059Z",
    fill: "url(#paint124_linear)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M500.461 257.28H494.314V264.715H500.461V257.28Z",
    fill: "url(#paint125_linear)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M500.461 243.5H494.314V250.934H500.461V243.5Z",
    fill: "url(#paint126_linear)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M500.461 229.72H494.314V237.155H500.461V229.72Z",
    fill: "url(#paint127_linear)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M502.562 214.465H346.169V225.19H502.562V214.465Z",
    fill: "#02247D"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M502.561 226.19H346.169C345.617 226.19 345.169 225.743 345.169 225.19V214.466C345.169 213.913 345.617 213.466 346.169 213.466H502.562C503.114 213.466 503.562 213.913 503.562 214.466V225.19C503.561 225.742 503.113 226.19 502.561 226.19ZM347.169 224.19H501.562V215.466H347.169V224.19Z",
    fill: "url(#paint128_linear)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M368.977 222.301H352.568C351.362 222.301 350.385 221.324 350.385 220.119V219.536C350.385 218.331 351.362 217.353 352.568 217.353H368.977C370.183 217.353 371.16 218.331 371.16 219.536V220.119C371.16 221.324 370.183 222.301 368.977 222.301Z",
    fill: "url(#paint129_linear)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M393.086 222.301H376.676C375.471 222.301 374.493 221.324 374.493 220.119V219.536C374.493 218.331 375.471 217.353 376.676 217.353H393.086C394.291 217.353 395.269 218.331 395.269 219.536V220.119C395.268 221.324 394.291 222.301 393.086 222.301Z",
    fill: "url(#paint130_linear)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M417.194 222.301H400.785C399.579 222.301 398.602 221.324 398.602 220.119V219.536C398.602 218.331 399.579 217.353 400.785 217.353H417.194C418.4 217.353 419.377 218.331 419.377 219.536V220.119C419.376 221.324 418.399 222.301 417.194 222.301Z",
    fill: "url(#paint131_linear)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M441.302 222.301H424.893C423.687 222.301 422.71 221.324 422.71 220.119V219.536C422.71 218.331 423.687 217.353 424.893 217.353H441.302C442.507 217.353 443.485 218.331 443.485 219.536V220.119C443.485 221.324 442.507 222.301 441.302 222.301Z",
    fill: "url(#paint132_linear)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M465.41 222.301H449.001C447.795 222.301 446.818 221.324 446.818 220.119V219.536C446.818 218.331 447.795 217.353 449.001 217.353H465.41C466.616 217.353 467.593 218.331 467.593 219.536V220.119C467.592 221.324 466.615 222.301 465.41 222.301Z",
    fill: "url(#paint133_linear)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M473.356 277.157L475.578 277.616L476.548 272.926L474.326 272.466C474.365 270.595 474.002 268.779 473.304 267.118L475.201 265.87L472.57 261.867L470.673 263.115C469.692 262.093 468.536 261.219 467.243 260.552C466.909 260.378 466.563 260.218 466.21 260.073C466.197 260.067 466.18 260.062 466.168 260.056L466.631 257.833L461.941 256.862L461.481 259.087C460.99 259.075 460.502 259.095 460.02 259.138C458.665 259.259 457.356 259.591 456.13 260.109L454.882 258.213L450.882 260.842L452.128 262.738C450.827 263.986 449.775 265.51 449.068 267.244L446.846 266.784L445.876 271.475L448.099 271.934C448.059 273.805 448.419 275.622 449.12 277.284L447.224 278.53L449.852 282.532L451.751 281.285C452.998 282.589 454.522 283.64 456.257 284.345L455.797 286.57L460.485 287.539L460.944 285.317C461.439 285.327 461.926 285.31 462.407 285.267C463.76 285.144 465.07 284.81 466.294 284.296L467.542 286.192L471.543 283.559L470.297 281.664C471.597 280.413 472.649 278.89 473.356 277.157ZM462.093 281.846C461.166 281.93 460.209 281.882 459.25 281.682C454.013 280.6 450.644 275.475 451.726 270.239C452.613 265.958 456.192 262.929 460.33 262.551C461.257 262.467 462.214 262.515 463.172 262.715C463.725 262.83 464.254 262.987 464.763 263.19C465.12 263.327 465.466 263.487 465.798 263.666C469.476 265.642 471.586 269.862 470.696 274.163C469.811 278.44 466.232 281.468 462.093 281.846ZM461.22 282.885C460.49 282.885 459.762 282.811 459.046 282.66C456.254 282.084 453.851 280.452 452.283 278.067C450.715 275.682 450.169 272.83 450.747 270.035C451.709 265.393 455.524 261.985 460.24 261.555C461.291 261.458 462.346 261.52 463.378 261.737C463.979 261.861 464.57 262.037 465.132 262.259C465.515 262.406 465.902 262.584 466.274 262.785C470.406 265.004 472.628 269.766 471.677 274.364C470.716 279.004 466.902 282.411 462.185 282.842C461.863 282.871 461.541 282.885 461.22 282.885ZM461.203 263.512C460.942 263.512 460.682 263.524 460.421 263.547C456.588 263.897 453.487 266.668 452.705 270.441C452.236 272.712 452.679 275.031 453.954 276.969C455.229 278.907 457.182 280.234 459.453 280.702C460.293 280.877 461.148 280.925 462.002 280.849C465.835 280.499 468.936 277.73 469.717 273.958C470.49 270.221 468.684 266.35 465.325 264.545C465.025 264.384 464.716 264.241 464.404 264.12C463.941 263.937 463.461 263.795 462.97 263.693C462.387 263.573 461.796 263.512 461.203 263.512Z",
    fill: "#02247D"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M419.381 267.072L422.472 267.712L423.821 261.188L420.73 260.548C420.785 257.946 420.28 255.421 419.308 253.11L421.947 251.374L418.287 245.806L415.649 247.542C414.284 246.118 412.677 244.906 410.878 243.976C410.414 243.735 409.932 243.511 409.441 243.31C409.423 243.302 409.4 243.294 409.382 243.287L410.027 240.194L403.503 238.845L402.863 241.939C402.18 241.923 401.501 241.949 400.831 242.009C398.946 242.178 397.125 242.639 395.421 243.359L393.685 240.72L388.122 244.378L389.854 247.015C388.045 248.751 386.582 250.87 385.599 253.283L382.508 252.644L381.159 259.167L384.25 259.806C384.195 262.409 384.695 264.937 385.67 267.247L383.034 268.979L386.69 274.546L389.332 272.812C391.067 274.625 393.186 276.088 395.6 277.068L394.959 280.163L401.48 281.511L402.119 278.419C402.807 278.433 403.484 278.411 404.154 278.351C406.036 278.181 407.858 277.716 409.56 276.999L411.296 279.638L416.861 275.977L415.129 273.34C416.935 271.603 418.398 269.484 419.381 267.072ZM403.715 273.595C402.425 273.713 401.094 273.646 399.761 273.367C392.476 271.861 387.789 264.734 389.295 257.449C390.528 251.496 395.506 247.283 401.263 246.758C402.553 246.64 403.884 246.707 405.217 246.985C405.985 247.145 406.721 247.364 407.429 247.645C407.925 247.836 408.407 248.059 408.868 248.307C413.984 251.055 416.918 256.925 415.681 262.907C414.45 268.858 409.471 273.07 403.715 273.595ZM402.497 274.651C401.511 274.651 400.527 274.549 399.556 274.346C391.744 272.732 386.701 265.061 388.315 257.247C389.617 250.96 394.784 246.345 401.172 245.762C402.589 245.629 404.019 245.715 405.42 246.005C406.24 246.176 407.04 246.415 407.797 246.715C408.308 246.911 408.83 247.152 409.341 247.426C414.938 250.433 417.947 256.882 416.659 263.11C415.358 269.394 410.192 274.008 403.804 274.591C403.37 274.631 402.934 274.651 402.497 274.651ZM402.481 247.702C402.106 247.702 401.73 247.72 401.355 247.754C395.85 248.256 391.397 252.234 390.274 257.652C388.882 264.384 393.229 270.996 399.963 272.387C401.17 272.639 402.402 272.709 403.623 272.598C409.128 272.096 413.581 268.119 414.701 262.703C415.812 257.336 413.219 251.777 408.395 249.186C407.958 248.952 407.513 248.747 407.071 248.577C406.41 248.315 405.72 248.11 405.012 247.962C404.177 247.789 403.329 247.702 402.481 247.702Z",
    fill: "#02247D"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M402.488 287.69C402.152 287.69 401.817 287.684 401.483 287.671C400.931 287.651 400.5 287.188 400.52 286.636C400.541 286.084 400.985 285.653 401.556 285.673C402.506 285.706 403.477 285.69 404.43 285.617C404.981 285.566 405.461 285.989 405.502 286.54C405.544 287.091 405.13 287.57 404.58 287.611C403.888 287.663 403.185 287.69 402.488 287.69ZM396.592 287.034C396.519 287.034 396.445 287.026 396.37 287.01C395.364 286.781 394.362 286.494 393.391 286.156C392.87 285.973 392.595 285.403 392.776 284.882C392.958 284.361 393.53 284.083 394.05 284.268C394.95 284.582 395.88 284.849 396.812 285.06C397.351 285.182 397.688 285.718 397.566 286.256C397.462 286.72 397.049 287.034 396.592 287.034ZM409.405 286.783C408.964 286.783 408.56 286.489 408.44 286.043C408.296 285.51 408.612 284.961 409.145 284.817C410.071 284.568 410.99 284.264 411.874 283.918C412.389 283.715 412.969 283.969 413.171 284.481C413.373 284.995 413.12 285.576 412.607 285.778C411.653 286.153 410.664 286.479 409.666 286.749C409.578 286.773 409.49 286.783 409.405 286.783ZM389.199 284.143C389.03 284.143 388.858 284.1 388.7 284.009C387.811 283.496 386.939 282.926 386.108 282.315C385.663 281.988 385.568 281.362 385.895 280.917C386.224 280.473 386.848 280.378 387.293 280.704C388.064 281.272 388.874 281.802 389.699 282.277C390.177 282.553 390.341 283.165 390.065 283.643C389.882 283.963 389.545 284.143 389.199 284.143ZM416.674 283.602C416.342 283.602 416.017 283.437 415.827 283.135C415.533 282.668 415.673 282.05 416.14 281.755C416.945 281.249 417.732 280.689 418.481 280.091C418.912 279.746 419.543 279.818 419.886 280.248C420.231 280.68 420.16 281.309 419.729 281.653C418.922 282.298 418.074 282.901 417.206 283.448C417.04 283.552 416.856 283.602 416.674 283.602ZM382.991 279.199C382.723 279.199 382.456 279.092 382.259 278.88C381.555 278.124 380.889 277.323 380.279 276.5C379.95 276.057 380.043 275.43 380.487 275.101C380.932 274.775 381.558 274.867 381.886 275.309C382.452 276.073 383.071 276.816 383.724 277.519C384.1 277.923 384.078 278.556 383.673 278.932C383.48 279.111 383.236 279.199 382.991 279.199ZM422.683 278.42C422.452 278.42 422.22 278.34 422.031 278.178C421.613 277.817 421.566 277.186 421.927 276.767C422.549 276.046 423.137 275.28 423.677 274.489C423.989 274.032 424.612 273.917 425.067 274.226C425.524 274.538 425.641 275.16 425.33 275.616C424.748 276.469 424.113 277.296 423.442 278.074C423.243 278.302 422.964 278.42 422.683 278.42ZM378.507 272.654C378.136 272.654 377.779 272.447 377.607 272.091C377.158 271.164 376.757 270.202 376.416 269.231C376.233 268.71 376.507 268.139 377.028 267.956C377.548 267.771 378.12 268.047 378.303 268.567C378.62 269.468 378.991 270.36 379.407 271.218C379.648 271.715 379.44 272.314 378.943 272.554C378.802 272.621 378.653 272.654 378.507 272.654ZM426.909 271.702C426.775 271.702 426.639 271.676 426.51 271.618C426.004 271.397 425.773 270.808 425.993 270.302C426.375 269.428 426.711 268.522 426.993 267.608C427.155 267.08 427.714 266.784 428.243 266.947C428.771 267.11 429.067 267.67 428.904 268.198C428.6 269.182 428.238 270.16 427.826 271.103C427.662 271.479 427.294 271.702 426.909 271.702ZM376.155 265.075C375.669 265.075 375.243 264.72 375.168 264.224C375.015 263.209 374.916 262.172 374.876 261.142C374.855 260.59 375.284 260.125 375.836 260.104C376.403 260.093 376.853 260.513 376.874 261.064C376.912 262.021 377.002 262.983 377.145 263.925C377.228 264.471 376.852 264.981 376.306 265.063C376.255 265.072 376.204 265.075 376.155 265.075ZM428.959 264.036C428.922 264.036 428.884 264.034 428.847 264.03C428.298 263.968 427.902 263.474 427.964 262.926C428.069 261.978 428.123 261.013 428.123 260.056V259.948C428.123 259.395 428.571 258.948 429.123 258.948C429.675 258.948 430.123 259.395 430.123 259.948V260.056C430.123 261.086 430.065 262.126 429.952 263.147C429.895 263.658 429.462 264.036 428.959 264.036ZM376.142 257.141C376.093 257.141 376.044 257.138 375.995 257.13C375.449 257.05 375.071 256.541 375.152 255.995C375.302 254.976 375.511 253.956 375.775 252.961C375.916 252.427 376.463 252.11 376.997 252.25C377.531 252.392 377.85 252.938 377.708 253.473C377.464 254.396 377.27 255.343 377.13 256.286C377.056 256.783 376.629 257.141 376.142 257.141ZM428.642 256.001C428.172 256.001 427.752 255.668 427.661 255.189C427.481 254.251 427.246 253.315 426.961 252.404C426.796 251.877 427.09 251.315 427.617 251.151C428.142 250.989 428.705 251.279 428.87 251.806C429.177 252.789 429.432 253.801 429.625 254.812C429.729 255.355 429.374 255.878 428.831 255.983C428.768 255.995 428.704 256.001 428.642 256.001ZM378.46 249.552C378.315 249.552 378.168 249.521 378.028 249.453C377.53 249.215 377.32 248.617 377.558 248.119C378.003 247.191 378.506 246.278 379.053 245.405C379.345 244.937 379.962 244.795 380.431 245.089C380.899 245.383 381.041 245.999 380.747 246.468C380.24 247.278 379.773 248.124 379.361 248.985C379.19 249.343 378.832 249.552 378.46 249.552ZM425.995 248.52C425.638 248.52 425.292 248.329 425.112 247.992C424.663 247.151 424.16 246.326 423.618 245.54C423.305 245.085 423.42 244.462 423.874 244.149C424.328 243.836 424.951 243.95 425.265 244.405C425.849 245.254 426.391 246.143 426.875 247.049C427.135 247.536 426.952 248.143 426.464 248.403C426.316 248.482 426.154 248.52 425.995 248.52ZM382.92 242.988C382.677 242.988 382.434 242.9 382.242 242.722C381.836 242.347 381.811 241.714 382.186 241.309C382.884 240.553 383.633 239.829 384.411 239.156C384.828 238.794 385.46 238.841 385.822 239.258C386.183 239.676 386.137 240.307 385.72 240.669C384.998 241.293 384.303 241.965 383.655 242.667C383.458 242.879 383.19 242.988 382.92 242.988ZM421.256 242.157C421.001 242.157 420.747 242.06 420.551 241.867C419.871 241.192 419.148 240.551 418.402 239.958C417.969 239.615 417.897 238.986 418.24 238.554C418.585 238.121 419.213 238.048 419.645 238.392C420.449 239.03 421.228 239.721 421.96 240.448C422.352 240.838 422.354 241.47 421.965 241.862C421.77 242.058 421.513 242.157 421.256 242.157ZM389.111 238.022C388.767 238.022 388.432 237.844 388.246 237.525C387.968 237.048 388.13 236.436 388.607 236.158C389.495 235.64 390.424 235.169 391.367 234.754C391.875 234.531 392.464 234.761 392.685 235.267C392.907 235.772 392.678 236.363 392.172 236.584C391.297 236.969 390.437 237.407 389.613 237.887C389.454 237.978 389.281 238.022 389.111 238.022ZM414.856 237.461C414.699 237.461 414.54 237.424 414.392 237.347C413.544 236.901 412.664 236.5 411.777 236.157C411.262 235.957 411.007 235.377 411.207 234.862C411.407 234.347 411.986 234.092 412.501 234.292C413.458 234.664 414.407 235.097 415.321 235.576C415.81 235.833 415.998 236.438 415.741 236.927C415.563 237.267 415.216 237.461 414.856 237.461ZM396.485 235.102C396.03 235.102 395.618 234.789 395.511 234.327C395.387 233.789 395.723 233.252 396.261 233.128C397.26 232.898 398.287 232.722 399.314 232.605C399.864 232.544 400.358 232.935 400.421 233.485C400.484 234.033 400.09 234.529 399.541 234.591C398.588 234.7 397.636 234.863 396.71 235.077C396.635 235.094 396.559 235.102 396.485 235.102ZM407.359 234.866C407.299 234.866 407.238 234.861 407.177 234.849C406.237 234.676 405.277 234.554 404.326 234.486C403.775 234.447 403.36 233.969 403.399 233.418C403.438 232.867 403.924 232.45 404.467 232.492C405.492 232.564 406.526 232.696 407.539 232.883C408.082 232.983 408.441 233.504 408.341 234.048C408.253 234.53 407.832 234.866 407.359 234.866Z",
    fill: "url(#paint134_linear)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M459.22 292.341C459.186 292.341 459.152 292.339 459.116 292.336C458.064 292.228 457.013 292.035 455.993 291.764C455.459 291.621 455.142 291.074 455.284 290.54C455.427 290.006 455.971 289.692 456.508 289.83C457.426 290.075 458.373 290.248 459.321 290.346C459.87 290.403 460.27 290.894 460.213 291.444C460.161 291.958 459.727 292.341 459.22 292.341ZM464.237 292.205C463.754 292.205 463.328 291.853 463.251 291.36C463.165 290.814 463.538 290.302 464.084 290.216C465.022 290.069 465.958 289.845 466.864 289.549C467.393 289.38 467.954 289.667 468.124 290.191C468.295 290.716 468.008 291.281 467.483 291.452C466.476 291.779 465.437 292.029 464.394 292.193C464.341 292.201 464.289 292.205 464.237 292.205ZM451.609 289.879C451.44 289.879 451.268 289.836 451.11 289.745C450.196 289.218 449.315 288.613 448.492 287.947C448.063 287.6 447.996 286.97 448.344 286.541C448.691 286.111 449.321 286.046 449.75 286.393C450.492 286.993 451.286 287.539 452.109 288.013C452.588 288.288 452.752 288.901 452.476 289.379C452.291 289.699 451.954 289.879 451.609 289.879ZM471.703 289.334C471.376 289.334 471.057 289.175 470.865 288.881C470.563 288.418 470.694 287.798 471.156 287.496C471.955 286.975 472.719 286.388 473.425 285.751C473.834 285.382 474.467 285.414 474.837 285.824C475.207 286.235 475.174 286.867 474.764 287.237C473.981 287.942 473.135 288.593 472.249 289.172C472.08 289.282 471.891 289.334 471.703 289.334ZM445.66 284.533C445.351 284.533 445.047 284.39 444.851 284.123C444.227 283.269 443.667 282.359 443.186 281.421C442.935 280.93 443.128 280.327 443.62 280.075C444.111 279.82 444.714 280.017 444.966 280.509C445.399 281.355 445.904 282.174 446.466 282.944C446.792 283.39 446.694 284.016 446.248 284.341C446.071 284.471 445.864 284.533 445.66 284.533ZM477.355 283.677C477.168 283.677 476.979 283.625 476.811 283.515C476.348 283.214 476.216 282.595 476.518 282.132C477.038 281.332 477.498 280.486 477.885 279.616C478.11 279.111 478.701 278.885 479.206 279.11C479.71 279.335 479.937 279.925 479.712 280.43C479.282 281.395 478.771 282.334 478.194 283.221C478.003 283.517 477.682 283.677 477.355 283.677ZM442.391 277.235C441.929 277.235 441.515 276.914 441.414 276.444C441.194 275.413 441.054 274.354 440.997 273.297C440.967 272.745 441.391 272.275 441.942 272.244C442.495 272.227 442.964 272.638 442.994 273.189C443.045 274.143 443.172 275.097 443.37 276.026C443.485 276.566 443.141 277.097 442.601 277.213C442.531 277.228 442.461 277.235 442.391 277.235ZM480.223 276.207C480.171 276.207 480.119 276.203 480.067 276.195C479.521 276.109 479.148 275.597 479.234 275.051C479.381 274.113 479.456 273.153 479.456 272.197C479.456 271.644 479.904 271.159 480.456 271.159C481.008 271.159 481.456 271.567 481.456 272.12V272.197C481.456 273.256 481.373 274.32 481.21 275.361C481.133 275.856 480.707 276.207 480.223 276.207ZM442.377 269.237C442.309 269.237 442.24 269.23 442.171 269.216C441.63 269.103 441.284 268.573 441.397 268.032C441.614 266.997 441.915 265.971 442.293 264.983C442.489 264.466 443.069 264.207 443.584 264.405C444.1 264.602 444.359 265.18 444.162 265.696C443.822 266.586 443.551 267.509 443.356 268.442C443.256 268.913 442.841 269.237 442.377 269.237ZM479.785 268.145C479.345 268.145 478.941 267.852 478.82 267.407C478.571 266.49 478.247 265.584 477.856 264.716C477.629 264.212 477.853 263.62 478.356 263.393C478.861 263.167 479.452 263.39 479.679 263.894C480.114 264.86 480.474 265.866 480.751 266.884C480.896 267.417 480.58 267.966 480.047 268.111C479.959 268.134 479.871 268.145 479.785 268.145ZM445.615 261.922C445.412 261.922 445.207 261.86 445.03 261.732C444.583 261.409 444.483 260.784 444.806 260.336C445.425 259.482 446.118 258.669 446.864 257.919C447.255 257.526 447.887 257.524 448.279 257.914C448.67 258.304 448.672 258.936 448.282 259.328C447.609 260.005 446.985 260.738 446.427 261.51C446.231 261.779 445.926 261.922 445.615 261.922ZM476.126 261.035C475.836 261.035 475.549 260.91 475.351 260.668C474.748 259.93 474.082 259.233 473.373 258.599C472.961 258.231 472.927 257.598 473.295 257.187C473.664 256.776 474.295 256.74 474.707 257.109C475.494 257.813 476.231 258.585 476.9 259.403C477.25 259.831 477.186 260.461 476.758 260.81C476.572 260.961 476.348 261.035 476.126 261.035ZM451.548 256.554C451.204 256.554 450.869 256.376 450.683 256.057C450.405 255.58 450.567 254.968 451.044 254.69C451.96 254.157 452.922 253.694 453.904 253.314C454.42 253.118 454.999 253.371 455.197 253.886C455.396 254.401 455.14 254.98 454.625 255.179C453.741 255.521 452.874 255.938 452.05 256.418C451.892 256.51 451.718 256.554 451.548 256.554ZM469.893 256.019C469.742 256.019 469.588 255.985 469.443 255.912C468.59 255.481 467.699 255.115 466.795 254.825C466.269 254.656 465.98 254.093 466.149 253.567C466.318 253.041 466.88 252.752 467.407 252.921C468.411 253.243 469.399 253.65 470.345 254.127C470.838 254.376 471.036 254.978 470.787 255.471C470.611 255.818 470.259 256.019 469.893 256.019ZM459.143 254.064C458.639 254.064 458.205 253.683 458.15 253.169C458.092 252.62 458.49 252.128 459.039 252.069C460.087 251.957 461.164 251.924 462.211 251.978C462.762 252.005 463.188 252.475 463.16 253.027C463.133 253.579 462.663 254.021 462.112 253.976C461.168 253.927 460.196 253.956 459.251 254.057C459.214 254.062 459.178 254.064 459.143 254.064Z",
    fill: "url(#paint135_linear)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M468.301 255.309C468.195 255.309 468.086 255.292 467.979 255.255L465.139 254.289C464.616 254.111 464.336 253.544 464.514 253.02C464.692 252.498 465.26 252.213 465.783 252.396L468.623 253.362C469.146 253.54 469.426 254.107 469.248 254.631C469.107 255.047 468.718 255.309 468.301 255.309ZM460.728 252.733C460.622 252.733 460.513 252.716 460.406 252.679L457.566 251.713C457.043 251.535 456.763 250.968 456.941 250.444C457.119 249.922 457.685 249.637 458.21 249.82L461.05 250.786C461.573 250.964 461.853 251.531 461.675 252.055C461.533 252.471 461.144 252.733 460.728 252.733ZM453.154 250.157C453.048 250.157 452.939 250.14 452.832 250.103L449.992 249.137C449.469 248.959 449.189 248.392 449.367 247.868C449.544 247.346 450.112 247.061 450.636 247.244L453.476 248.21C453.999 248.388 454.279 248.955 454.101 249.479C453.959 249.895 453.57 250.157 453.154 250.157ZM445.58 247.58C445.474 247.58 445.365 247.563 445.258 247.526L442.418 246.56C441.895 246.382 441.615 245.815 441.793 245.291C441.971 244.769 442.539 244.484 443.062 244.667L445.902 245.633C446.425 245.811 446.705 246.378 446.527 246.902C446.385 247.319 445.996 247.58 445.58 247.58ZM438.006 245.004C437.9 245.004 437.791 244.987 437.684 244.95L434.844 243.984C434.321 243.806 434.041 243.239 434.219 242.715C434.397 242.193 434.965 241.908 435.488 242.091L438.328 243.057C438.851 243.235 439.131 243.802 438.953 244.326C438.811 244.742 438.423 245.004 438.006 245.004ZM430.432 242.428C430.325 242.428 430.217 242.411 430.11 242.374L427.27 241.408C426.747 241.23 426.467 240.663 426.645 240.139C426.822 239.617 427.389 239.331 427.914 239.515L430.754 240.481C431.277 240.659 431.557 241.226 431.379 241.75C431.237 242.166 430.848 242.428 430.432 242.428ZM422.858 239.852C422.752 239.852 422.643 239.835 422.536 239.798L419.696 238.832C419.173 238.654 418.893 238.087 419.071 237.563C419.249 237.041 419.817 236.755 420.34 236.939L423.18 237.905C423.703 238.083 423.983 238.65 423.805 239.174C423.663 239.59 423.275 239.852 422.858 239.852ZM415.284 237.276C415.178 237.276 415.069 237.259 414.962 237.222L412.122 236.256C411.599 236.078 411.319 235.511 411.497 234.987C411.675 234.465 412.244 234.181 412.766 234.363L415.606 235.329C416.129 235.507 416.409 236.074 416.231 236.598C416.09 237.014 415.701 237.276 415.284 237.276Z",
    fill: "url(#paint136_linear)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M458.266 292.218C458.238 292.218 458.21 292.217 458.182 292.214L455.192 291.965C454.642 291.92 454.233 291.437 454.278 290.886C454.323 290.335 454.802 289.907 455.358 289.973L458.348 290.222C458.898 290.267 459.307 290.75 459.262 291.301C459.218 291.824 458.78 292.218 458.266 292.218ZM450.293 291.555C450.265 291.555 450.237 291.554 450.209 291.551L447.22 291.302C446.67 291.257 446.261 290.774 446.306 290.223C446.351 289.672 446.837 289.26 447.386 289.31L450.375 289.559C450.925 289.604 451.334 290.087 451.289 290.638C451.245 291.16 450.808 291.555 450.293 291.555ZM442.321 290.892C442.293 290.892 442.265 290.891 442.237 290.888L439.247 290.639C438.697 290.594 438.288 290.111 438.333 289.56C438.378 289.009 438.861 288.594 439.413 288.647L442.403 288.896C442.953 288.941 443.362 289.424 443.317 289.975C443.273 290.497 442.836 290.892 442.321 290.892ZM434.348 290.229C434.32 290.229 434.292 290.228 434.264 290.225L431.274 289.976C430.724 289.931 430.315 289.448 430.36 288.897C430.405 288.346 430.885 287.928 431.44 287.984L434.43 288.233C434.98 288.278 435.389 288.761 435.344 289.312C435.301 289.834 434.863 290.229 434.348 290.229ZM426.376 289.566C426.348 289.566 426.32 289.565 426.292 289.562L423.303 289.313C422.753 289.268 422.344 288.785 422.389 288.234C422.434 287.683 422.911 287.262 423.469 287.321L426.458 287.57C427.008 287.615 427.417 288.098 427.372 288.649C427.328 289.171 426.89 289.566 426.376 289.566ZM418.404 288.903C418.376 288.903 418.348 288.902 418.321 288.899L415.331 288.651C414.78 288.606 414.371 288.123 414.417 287.572C414.462 287.022 414.949 286.6 415.496 286.659L418.486 286.907C419.037 286.952 419.446 287.435 419.4 287.986C419.356 288.507 418.919 288.903 418.404 288.903ZM410.431 288.24C410.403 288.24 410.375 288.239 410.348 288.236L407.358 287.988C406.807 287.943 406.398 287.46 406.444 286.909C406.49 286.359 406.976 285.934 407.523 285.996L410.513 286.244C411.064 286.289 411.473 286.772 411.427 287.323C411.383 287.844 410.946 288.24 410.431 288.24ZM402.459 287.576C402.431 287.576 402.403 287.575 402.376 287.572L399.386 287.324C398.835 287.279 398.426 286.796 398.472 286.245C398.518 285.695 399.003 285.266 399.551 285.332L402.541 285.58C403.092 285.625 403.501 286.108 403.455 286.659C403.411 287.181 402.974 287.576 402.459 287.576Z",
    fill: "url(#paint137_linear)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M319.209 451.865C318.201 451.865 317.182 451.588 316.268 451.008C313.703 449.381 313.405 446.223 314.571 443.418C324.54 419.416 357.983 375.009 357.983 375.009H298.075C295.037 375.009 292.575 372.546 292.575 369.509C292.575 366.472 295.037 364.009 298.075 364.009H367.987C369.993 364.009 371.84 365.102 372.807 366.86C373.773 368.618 373.706 370.762 372.631 372.457C372.631 372.457 337.902 429.704 325.706 448.917C324.658 450.567 321.03 451.865 319.209 451.865Z",
    fill: "url(#paint138_linear)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M314.754 436.477C314.745 436.469 314.736 436.463 314.727 436.457C314.719 436.524 314.731 436.518 314.754 436.477Z",
    fill: "#02247D"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M314.709 437.504C314.614 437.504 314.518 437.489 314.425 437.46C313.968 437.314 313.677 436.815 313.734 436.34C313.775 435.995 313.992 435.695 314.308 435.549C314.624 435.403 314.993 435.432 315.282 435.625C315.303 435.639 315.349 435.671 315.368 435.687C315.755 435.988 315.867 436.525 315.632 436.956C315.448 437.29 315.081 437.504 314.709 437.504Z",
    fill: "url(#paint139_linear)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M368.101 358.748C358.072 356.416 337.655 354.165 321.472 353.148V342.823H273.762V356.026C273.938 369.205 279.25 379.845 293.803 379.845C293.925 379.845 294.049 379.837 294.171 379.835C294.234 379.835 294.289 379.845 294.353 379.845C308.532 379.809 348.278 379.575 348.278 379.575C322.277 412.798 315.215 435.632 314.755 436.475C323.062 442.579 332.955 441.952 333.032 441.83C333.032 441.83 362.5 396.033 372.887 379.844C379.085 370.184 374.373 360.208 368.101 358.748Z",
    fill: "#02247D"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M331.68 442.886C328.545 442.886 320.986 442.296 314.161 437.282C313.758 436.986 313.636 436.436 313.875 435.997C313.907 435.926 313.993 435.688 314.13 435.317C320.214 418.934 331.58 399.561 346.223 380.588C337.883 380.637 306.518 380.815 294.353 380.845C294.325 380.845 294.203 380.839 294.176 380.837L293.802 380.845C280.448 380.845 272.975 372.035 272.761 356.04V342.823C272.761 342.557 272.866 342.303 273.054 342.116C273.242 341.929 273.496 341.823 273.761 341.823H321.471C322.023 341.823 322.471 342.27 322.471 342.823V352.21C337.774 353.208 358.159 355.408 368.327 357.774C371.473 358.506 374.226 361.096 375.691 364.704C377.686 369.615 376.969 375.331 373.727 380.385C363.339 396.574 333.871 442.373 333.871 442.373C333.723 442.604 333.437 442.779 333.167 442.83C333.147 442.834 332.606 442.886 331.68 442.886ZM315.969 436.113C322.948 440.914 330.731 440.95 332.452 440.884C335.414 436.28 362.236 394.593 372.044 379.306C374.932 374.806 375.586 369.759 373.839 365.458C372.618 362.452 370.388 360.309 367.875 359.723C357.604 357.334 336.725 355.11 321.41 354.148C320.883 354.115 320.472 353.678 320.472 353.15V343.825H274.762V356.028C274.901 366.43 278.318 378.846 293.803 378.846L294.155 378.836C294.193 378.843 294.303 378.842 294.334 378.844C308.365 378.811 347.875 378.579 348.272 378.577C348.274 378.577 348.276 378.577 348.278 378.577C348.659 378.577 349.007 378.794 349.175 379.137C349.344 379.481 349.301 379.892 349.065 380.194C333.935 399.526 322.195 419.35 316.006 436.014C315.993 436.048 315.981 436.081 315.969 436.113Z",
    fill: "url(#paint140_linear)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M315.306 444.939C320.389 448.356 327.413 447.522 327.639 447.522C327.639 447.522 342.994 455.643 351.027 455.626C354.454 455.618 355.767 463.108 347.86 463.126C333.296 463.156 322.577 460.547 322.577 460.547L322.021 463.097C322.045 463.097 311.923 463.126 311.923 463.126C311.92 461.521 309.712 457.053 309.704 453.228C309.697 449.959 310.812 441.918 315.306 444.939Z",
    fill: "#02247D"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M347.613 464.125C335.741 464.125 326.333 462.369 323.341 461.739L323.022 463.204C323.015 464.093 322.793 464.094 316.976 464.11L311.927 464.124C311.926 464.124 311.925 464.124 311.924 464.124C311.66 464.124 311.406 464.02 311.218 463.833C311.03 463.645 310.924 463.392 310.924 463.126C310.923 462.649 310.562 461.517 310.213 460.421C309.543 458.319 308.71 455.705 308.705 453.229C308.705 452.911 308.726 445.4 312.036 443.632C312.828 443.207 314.137 442.947 315.864 444.109C319.893 446.818 325.296 446.707 327.431 446.535C327.544 446.525 327.615 446.522 327.639 446.522C327.802 446.522 327.962 446.562 328.106 446.638C328.257 446.718 343.304 454.625 351.002 454.625C351.013 454.624 351.023 454.627 351.033 454.625C352.265 454.625 353.408 455.326 354.09 456.503C354.926 457.943 354.929 459.812 354.097 461.26C353.485 462.326 351.861 464.116 347.864 464.125C347.78 464.125 347.696 464.125 347.613 464.125ZM322.578 459.546C322.657 459.546 322.736 459.556 322.814 459.574C322.92 459.599 333.59 462.155 347.858 462.125C350.076 462.12 351.675 461.459 352.361 460.264C352.844 459.424 352.843 458.341 352.359 457.507C352.205 457.241 351.768 456.625 351.031 456.625C351.023 456.625 351.011 456.625 351.002 456.625C343.286 456.626 329.531 449.634 327.423 448.538C324.906 448.723 319.169 448.741 314.746 445.768C313.653 445.033 313.143 445.308 312.976 445.395C311.563 446.15 310.696 450.046 310.703 453.224C310.708 455.391 311.489 457.843 312.117 459.813C312.401 460.704 312.647 461.475 312.79 462.122L321.215 462.098L321.6 460.333C321.658 460.069 321.819 459.841 322.047 459.698C322.208 459.598 322.392 459.546 322.578 459.546Z",
    fill: "url(#paint141_linear)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M274.177 360.207C271.642 359.563 270.779 354.051 270.97 351.443C271.555 343.444 274.175 329.664 273.762 319.484C273.162 304.716 263.479 277.593 287.665 274.839C305.741 272.778 327.415 277.435 324.665 300.685C323.275 312.439 331.508 346.527 323.79 356.456C316.956 365.248 282.206 362.248 274.177 360.207Z",
    fill: "#02247D"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M298.346 363.395C287.883 363.395 277.598 362.11 273.93 361.177C270.428 360.286 269.804 353.677 269.972 351.37C270.17 348.663 270.603 345.272 271.06 341.682C271.985 334.429 273.033 326.208 272.762 319.524C272.647 316.696 272.189 313.375 271.704 309.857C270.272 299.477 268.649 287.712 274.363 280.352C277.191 276.709 281.628 274.52 287.551 273.845C294.285 273.076 310.935 272.284 320.067 281.456C324.74 286.149 326.621 292.658 325.658 300.802C325.181 304.837 325.898 311.865 326.657 319.307C328.14 333.846 329.822 350.325 324.579 357.07C320.793 361.943 309.468 363.395 298.346 363.395ZM274.424 359.24C282.364 361.259 316.62 364.053 323 355.844C327.75 349.732 326.041 332.975 324.667 319.511C323.863 311.629 323.168 304.822 323.671 300.569C324.559 293.062 322.869 287.107 318.649 282.869C310.132 274.316 294.222 275.101 287.777 275.833C282.334 276.453 278.464 278.333 275.943 281.58C270.746 288.275 272.307 299.597 273.685 309.585C274.177 313.151 274.642 316.52 274.76 319.443C275.039 326.297 273.979 334.605 273.044 341.936C272.59 345.499 272.161 348.864 271.967 351.517C271.766 354.269 272.786 358.823 274.424 359.24Z",
    fill: "url(#paint142_linear)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M292.617 296.865H278.956V339.538H292.617C300.191 339.538 305.773 334.045 305.773 327.27V309.133C305.773 302.358 300.191 296.865 292.617 296.865Z",
    fill: "url(#paint143_linear)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M292.617 340.537H277.956V295.864H292.617C300.555 295.864 306.774 301.692 306.774 309.132V327.269C306.774 334.709 300.555 340.537 292.617 340.537ZM279.956 338.537H292.617C299.434 338.537 304.774 333.587 304.774 327.268V309.131C304.774 302.813 299.434 297.863 292.617 297.863H279.956V338.537Z",
    fill: "url(#paint144_linear)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M454.774 339.219C454.76 337.678 454.474 336.115 453.862 334.602C451.245 328.123 443.871 324.994 437.393 327.611C432.509 329.585 429.532 334.261 429.482 339.219H454.774Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M283.263 296.865H239.593C232.019 296.865 227.927 302.358 227.927 309.134V327.271C227.927 334.045 232.019 339.539 239.593 339.539H283.263C290.837 339.539 296.42 334.046 296.42 327.271V309.134C296.42 302.358 290.838 296.865 283.263 296.865Z",
    fill: "#02247D"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M283.263 340.537H239.593C232.017 340.537 226.927 335.205 226.927 327.268V309.131C226.927 301.195 232.017 295.863 239.593 295.863H283.263C291.201 295.863 297.42 301.691 297.42 309.131V327.268C297.42 334.709 291.202 340.537 283.263 340.537ZM239.593 297.865C233.114 297.865 228.927 302.288 228.927 309.133V327.27C228.927 334.116 233.114 338.539 239.593 338.539H283.263C290.08 338.539 295.42 333.589 295.42 327.27V309.133C295.42 302.815 290.08 297.865 283.263 297.865H239.593Z",
    fill: "url(#paint145_linear)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M331.551 379.642H285.062C281.14 379.642 277.96 382.37 277.96 385.735C277.96 389.1 281.139 391.829 285.062 391.829H331.551C335.473 391.829 338.653 389.1 338.653 385.735C338.653 382.37 335.473 379.642 331.551 379.642Z",
    fill: "url(#paint146_linear)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M331.551 392.828H285.062C280.595 392.828 276.96 389.645 276.96 385.734C276.96 381.823 280.594 378.641 285.062 378.641H331.551C336.018 378.641 339.653 381.823 339.653 385.734C339.653 389.645 336.018 392.828 331.551 392.828ZM285.062 380.642C281.698 380.642 278.96 382.926 278.96 385.735C278.96 388.544 281.697 390.829 285.062 390.829H331.551C334.915 390.829 337.653 388.544 337.653 385.735C337.653 382.926 334.916 380.642 331.551 380.642H285.062Z",
    fill: "url(#paint147_linear)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M305.39 379.642H242.133C238.211 379.642 235.031 382.37 235.031 385.735C235.031 389.1 238.21 391.829 242.133 391.829H305.39C309.312 391.829 312.492 389.1 312.492 385.735C312.492 382.37 309.313 379.642 305.39 379.642Z",
    fill: "#02247D"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M305.39 392.828H242.133C237.666 392.828 234.031 389.645 234.031 385.734C234.031 381.823 237.665 378.641 242.133 378.641H305.39C309.857 378.641 313.492 381.823 313.492 385.734C313.492 389.645 309.858 392.828 305.39 392.828ZM242.133 380.642C238.769 380.642 236.031 382.926 236.031 385.735C236.031 388.544 238.768 390.829 242.133 390.829H305.39C308.754 390.829 311.492 388.544 311.492 385.735C311.492 382.926 308.755 380.642 305.39 380.642H242.133Z",
    fill: "url(#paint148_linear)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M266.445 345.688C267.008 345.569 267.439 345.093 267.439 344.495C267.439 343.807 266.881 343.251 266.194 343.251H263.917V336.442C265.755 335.524 267.028 333.644 267.028 331.45V314.858C267.028 311.766 264.521 309.258 261.429 309.258C258.336 309.258 255.829 311.766 255.829 314.858V331.45C255.829 333.644 257.102 335.523 258.939 336.442V343.251H256.625C255.937 343.251 255.38 343.807 255.38 344.495C255.38 345.094 255.811 345.569 256.375 345.688C255.812 345.807 255.38 346.283 255.38 346.883C255.38 347.483 255.813 347.958 256.377 348.075C255.813 348.193 255.38 348.67 255.38 349.269C255.38 349.87 255.811 350.345 256.375 350.464C255.812 350.582 255.38 351.058 255.38 351.657C255.38 352.259 255.813 352.734 256.377 352.851C255.813 352.969 255.38 353.446 255.38 354.045C255.38 354.644 255.811 355.121 256.375 355.24C255.812 355.358 255.38 355.834 255.38 356.433C255.38 357.032 255.813 357.509 256.377 357.627C255.813 357.745 255.38 358.222 255.38 358.821C255.38 359.42 255.811 359.897 256.375 360.016C255.812 360.134 255.38 360.61 255.38 361.209C255.38 361.808 255.813 362.285 256.377 362.403C255.813 362.52 255.38 362.998 255.38 363.597C255.38 364.196 255.811 364.671 256.375 364.792C255.812 364.91 255.38 365.386 255.38 365.985C255.38 366.673 255.937 367.229 256.625 367.229H258.939C258.939 367.229 258.934 392.252 258.93 392.75C258.89 396.891 258.851 401.17 261.884 404.232C263.431 405.793 265.636 406.847 268.601 407.456V431.185H265.198V459.302H258.049C257.603 459.302 257.164 459.494 256.774 459.86L250.612 466.781C249.755 467.585 250.092 468.635 251.073 468.635H294.839C295.82 468.635 296.158 467.584 295.3 466.781L289.139 459.86C288.748 459.495 288.309 459.302 287.863 459.302H280.713V431.185H277.311V409.181H281.267C281.503 409.578 281.915 409.856 282.41 409.856H291.603C292.348 409.856 292.954 409.252 292.954 408.506C292.954 407.76 292.349 407.155 291.603 407.155H282.41C281.915 407.155 281.503 407.434 281.267 407.83H277.311V403.133H275.791V403.109C270.473 403.109 266.984 402.307 265.419 400.729C263.924 399.219 263.87 396.731 263.908 392.797C263.912 392.284 263.917 367.229 263.917 367.229H266.194C266.881 367.229 267.439 366.672 267.439 365.985C267.439 365.385 267.008 364.91 266.445 364.792C267.008 364.671 267.439 364.195 267.439 363.597C267.439 362.997 267.006 362.52 266.441 362.403C267.006 362.285 267.439 361.808 267.439 361.209C267.439 360.61 267.008 360.134 266.445 360.016C267.008 359.897 267.439 359.42 267.439 358.821C267.439 358.222 267.006 357.745 266.441 357.627C267.006 357.509 267.439 357.032 267.439 356.433C267.439 355.834 267.008 355.358 266.445 355.24C267.008 355.121 267.439 354.644 267.439 354.045C267.439 353.446 267.006 352.969 266.441 352.851C267.006 352.734 267.439 352.258 267.439 351.657C267.439 351.057 267.008 350.582 266.445 350.464C267.008 350.345 267.439 349.869 267.439 349.269C267.439 348.669 267.006 348.193 266.441 348.075C267.006 347.958 267.439 347.482 267.439 346.883C267.439 346.282 267.008 345.807 266.445 345.688Z",
    fill: "#02247D"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M294.839 469.641H251.073C250.236 469.641 249.537 469.192 249.252 468.468C248.936 467.668 249.195 466.743 249.929 466.056L256.027 459.201C256.669 458.595 257.346 458.308 258.049 458.308H264.198V431.191C264.198 430.638 264.646 430.191 265.198 430.191H267.601V408.263C264.825 407.59 262.717 406.499 261.174 404.942C257.846 401.583 257.891 396.888 257.931 392.747C257.934 392.317 257.939 372.905 257.94 368.235H256.626C255.388 368.235 254.381 367.228 254.381 365.99C254.381 365.552 254.507 365.141 254.731 364.796C254.508 364.45 254.381 364.04 254.381 363.603C254.381 363.165 254.507 362.754 254.73 362.409C254.507 362.063 254.381 361.653 254.381 361.215C254.381 360.777 254.507 360.366 254.73 360.021C254.507 359.675 254.381 359.265 254.381 358.827C254.381 358.389 254.507 357.978 254.73 357.633C254.507 357.287 254.381 356.877 254.381 356.439C254.381 356.001 254.507 355.59 254.73 355.245C254.507 354.899 254.381 354.489 254.381 354.051C254.381 353.613 254.507 353.203 254.731 352.858C254.508 352.512 254.381 352.101 254.381 351.663C254.381 351.225 254.507 350.814 254.73 350.469C254.507 350.123 254.381 349.713 254.381 349.275C254.381 348.837 254.507 348.427 254.731 348.082C254.508 347.736 254.381 347.326 254.381 346.888C254.381 346.45 254.507 346.039 254.73 345.694C254.507 345.348 254.381 344.938 254.381 344.501C254.381 343.263 255.388 342.256 256.626 342.256H257.94V337.033C256.007 335.83 254.83 333.746 254.83 331.456V314.864C254.83 311.225 257.79 308.264 261.43 308.264C265.069 308.264 268.029 311.225 268.029 314.864V331.456C268.029 333.747 266.852 335.832 264.918 337.034V342.256H266.195C267.433 342.256 268.44 343.263 268.44 344.501C268.44 344.939 268.314 345.349 268.091 345.694C268.314 346.04 268.44 346.45 268.44 346.888C268.44 347.326 268.314 347.737 268.09 348.082C268.313 348.428 268.44 348.838 268.44 349.275C268.44 349.713 268.314 350.124 268.091 350.469C268.314 350.815 268.44 351.225 268.44 351.663C268.44 352.102 268.314 352.513 268.09 352.858C268.313 353.204 268.44 353.614 268.44 354.051C268.44 354.489 268.314 354.9 268.091 355.245C268.314 355.591 268.44 356.001 268.44 356.439C268.44 356.877 268.314 357.288 268.091 357.633C268.314 357.979 268.44 358.389 268.44 358.827C268.44 359.265 268.314 359.676 268.091 360.021C268.314 360.367 268.44 360.777 268.44 361.215C268.44 361.653 268.314 362.064 268.091 362.409C268.314 362.755 268.44 363.165 268.44 363.603C268.44 364.041 268.314 364.451 268.09 364.796C268.313 365.142 268.44 365.552 268.44 365.99C268.44 367.228 267.433 368.235 266.195 368.235H264.918C264.917 372.965 264.912 392.353 264.909 392.811C264.873 396.488 264.913 398.802 266.131 400.031C267.074 400.981 269.515 402.115 275.793 402.115C275.867 402.115 275.939 402.123 276.009 402.138H277.313C277.865 402.138 278.313 402.585 278.313 403.138V406.836H280.79C281.222 406.406 281.797 406.161 282.412 406.161H291.605C292.901 406.161 293.955 407.216 293.955 408.512C293.955 409.808 292.901 410.862 291.605 410.862H282.412C281.796 410.862 281.221 410.617 280.789 410.187H278.312V430.191H280.714C281.266 430.191 281.714 430.638 281.714 431.191V458.308H287.864C288.567 458.308 289.244 458.594 289.823 459.135L296.048 466.121C296.718 466.742 296.978 467.666 296.662 468.468C296.375 469.192 295.676 469.641 294.839 469.641ZM251.192 467.636L294.727 467.641C294.701 467.605 294.665 467.562 294.617 467.517L288.392 460.531C288.315 460.465 288.099 460.308 287.863 460.308H280.713C280.161 460.308 279.713 459.861 279.713 459.308V432.191H277.311C276.759 432.191 276.311 431.744 276.311 431.191V409.187C276.311 408.926 276.411 408.69 276.573 408.511C276.41 408.333 276.311 408.097 276.311 407.836V404.138H275.791C275.716 404.138 275.643 404.13 275.573 404.115C270.027 404.093 266.472 403.217 264.709 401.439C262.933 399.645 262.867 396.985 262.908 392.793C262.912 392.292 262.917 367.484 262.917 367.234C262.917 366.681 263.365 366.234 263.917 366.234H266.194C266.329 366.234 266.439 366.124 266.439 365.989C266.439 365.853 266.313 365.79 266.238 365.774C265.776 365.676 265.446 365.268 265.445 364.796C265.445 364.323 265.775 363.915 266.237 363.817C266.312 363.8 266.44 363.737 266.44 363.6C266.44 363.463 266.314 363.401 266.239 363.385C265.775 363.288 265.442 362.879 265.442 362.406C265.442 361.933 265.775 361.523 266.239 361.427C266.314 361.411 266.44 361.349 266.44 361.212C266.44 361.084 266.333 361.017 266.24 360.997C265.778 360.9 265.446 360.492 265.446 360.019C265.446 359.546 265.777 359.137 266.239 359.04C266.314 359.024 266.44 358.961 266.44 358.823C266.44 358.686 266.313 358.623 266.237 358.607C265.773 358.51 265.441 358.101 265.442 357.628C265.443 357.155 265.775 356.746 266.239 356.649C266.314 356.633 266.44 356.571 266.44 356.434C266.44 356.297 266.315 356.235 266.24 356.219C265.778 356.122 265.446 355.714 265.446 355.241C265.446 354.768 265.777 354.359 266.239 354.262C266.332 354.242 266.44 354.174 266.44 354.045C266.44 353.908 266.312 353.845 266.236 353.829C265.773 353.731 265.441 353.322 265.442 352.849C265.443 352.376 265.775 351.968 266.239 351.871C266.332 351.852 266.44 351.784 266.44 351.656C266.44 351.519 266.315 351.457 266.24 351.441C265.778 351.344 265.446 350.936 265.446 350.463C265.446 349.99 265.777 349.581 266.239 349.484C266.332 349.464 266.44 349.396 266.44 349.267C266.44 349.13 266.312 349.067 266.236 349.051C265.773 348.953 265.441 348.544 265.442 348.071C265.443 347.598 265.775 347.19 266.239 347.093C266.332 347.074 266.44 347.006 266.44 346.879C266.44 346.742 266.315 346.679 266.24 346.663C265.778 346.566 265.446 346.158 265.446 345.685C265.446 345.212 265.777 344.803 266.239 344.706C266.314 344.69 266.44 344.627 266.44 344.491C266.44 344.356 266.33 344.246 266.195 344.246H263.918C263.366 344.246 262.918 343.799 262.918 343.246V336.438C262.918 336.059 263.132 335.712 263.471 335.543C265.049 334.755 266.029 333.185 266.029 331.445V314.853C266.029 312.317 263.966 310.253 261.43 310.253C258.894 310.253 256.83 312.316 256.83 314.853V331.445C256.83 333.183 257.81 334.754 259.388 335.543C259.727 335.713 259.941 336.059 259.941 336.438V343.246C259.941 343.799 259.493 344.246 258.941 344.246H256.627C256.492 344.246 256.382 344.356 256.382 344.491C256.382 344.627 256.508 344.69 256.583 344.706C257.045 344.804 257.376 345.213 257.376 345.685C257.376 346.157 257.044 346.566 256.582 346.663C256.508 346.679 256.382 346.742 256.382 346.879C256.382 347.006 256.49 347.074 256.582 347.093C257.045 347.19 257.378 347.598 257.379 348.071C257.38 348.545 257.048 348.954 256.586 349.051C256.51 349.067 256.382 349.13 256.382 349.267C256.382 349.396 256.49 349.464 256.583 349.484C257.045 349.582 257.376 349.991 257.376 350.463C257.376 350.935 257.044 351.344 256.582 351.441C256.508 351.457 256.382 351.519 256.382 351.656C256.382 351.793 256.508 351.856 256.582 351.871C257.045 351.968 257.378 352.376 257.379 352.849C257.38 353.323 257.048 353.732 256.586 353.829C256.51 353.845 256.382 353.908 256.382 354.045C256.382 354.174 256.49 354.242 256.583 354.262C257.045 354.36 257.376 354.769 257.376 355.241C257.376 355.713 257.044 356.122 256.582 356.219C256.508 356.235 256.382 356.297 256.382 356.434C256.382 356.571 256.508 356.634 256.582 356.649C257.046 356.746 257.378 357.154 257.379 357.628C257.38 358.102 257.047 358.511 256.584 358.607C256.509 358.623 256.382 358.686 256.382 358.823C256.382 358.961 256.508 359.024 256.583 359.04C257.045 359.138 257.376 359.547 257.376 360.019C257.376 360.491 257.044 360.9 256.582 360.997C256.49 361.017 256.382 361.084 256.382 361.212C256.382 361.349 256.508 361.412 256.582 361.427C257.046 361.524 257.379 361.933 257.379 362.406C257.379 362.879 257.046 363.289 256.582 363.385C256.508 363.4 256.382 363.463 256.382 363.6C256.382 363.737 256.509 363.8 256.585 363.817C257.047 363.915 257.377 364.323 257.377 364.796C257.377 365.268 257.046 365.676 256.584 365.774C256.509 365.79 256.383 365.853 256.383 365.989C256.383 366.124 256.493 366.234 256.628 366.234H258.942C259.207 366.234 259.462 366.339 259.649 366.527C259.836 366.715 259.942 366.969 259.942 367.234C259.942 368.256 259.937 392.268 259.933 392.763C259.893 396.879 259.856 400.766 262.597 403.533C263.998 404.948 266.029 405.913 268.805 406.482C269.27 406.578 269.604 406.987 269.604 407.461V431.19C269.604 431.743 269.156 432.19 268.604 432.19H266.201V459.307C266.201 459.86 265.753 460.307 265.201 460.307H258.052C257.817 460.307 257.601 460.463 257.461 460.595L251.363 467.45C251.28 467.527 251.228 467.587 251.192 467.636ZM282.005 408.512C282.05 408.562 282.091 408.616 282.127 408.676C282.169 408.745 282.26 408.862 282.411 408.862H291.604C291.797 408.862 291.954 408.705 291.954 408.512C291.954 408.319 291.797 408.161 291.604 408.161H282.411C282.261 408.161 282.168 408.278 282.127 408.348C282.091 408.407 282.051 408.462 282.005 408.512Z",
    fill: "url(#paint149_linear)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.201 231.424L518.456 212.16L549.192 256.282L468.529 375.728L380.201 231.424Z",
    fill: "url(#paint150_linear)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M572.68 332.28L581.451 279.569L559.307 219.598L557.54 220.251L579.513 279.752L570.822 331.971L572.68 332.28Z",
    fill: "url(#paint151_linear)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M568.786 332.28L577.559 279.569L555.414 219.598L553.648 220.251L575.619 279.752L566.929 331.971L568.786 332.28Z",
    fill: "url(#paint152_linear)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M578.573 287.314C582.747 287.314 586.13 283.931 586.13 279.757C586.13 275.583 582.747 272.2 578.573 272.2C574.399 272.2 571.016 275.583 571.016 279.757C571.016 283.931 574.399 287.314 578.573 287.314Z",
    fill: "#02247D"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M578.575 288.319C577.52 288.319 576.464 288.122 575.452 287.725C573.324 286.891 571.647 285.278 570.732 283.183C568.844 278.859 570.825 273.805 575.146 271.918C577.241 271 579.565 270.955 581.695 271.79C583.823 272.624 585.499 274.236 586.414 276.331C587.329 278.425 587.374 280.75 586.54 282.879C585.706 285.007 584.094 286.683 581.999 287.598C580.901 288.078 579.739 288.319 578.575 288.319ZM578.572 273.198C577.679 273.198 576.789 273.382 575.947 273.75C572.635 275.197 571.118 279.069 572.564 282.383C573.266 283.988 574.55 285.225 576.181 285.863C577.814 286.503 579.594 286.467 581.198 285.766C582.803 285.065 584.039 283.781 584.678 282.149C585.317 280.519 585.282 278.737 584.581 277.132C583.88 275.527 582.596 274.291 580.965 273.653C580.191 273.349 579.381 273.198 578.572 273.198Z",
    fill: "url(#paint153_linear)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M578.574 283.092C580.415 283.092 581.908 281.599 581.908 279.758C581.908 277.917 580.415 276.424 578.574 276.424C576.733 276.424 575.24 277.917 575.24 279.758C575.24 281.599 576.733 283.092 578.574 283.092Z",
    fill: "url(#paint154_linear)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M562.467 214.253C560.391 211.244 556.27 210.488 553.262 212.565L546.854 216.986C543.846 219.061 543.089 223.182 545.165 226.19C547.241 229.2 551.362 229.956 554.371 227.879L560.779 223.458C563.786 221.383 564.542 217.262 562.467 214.253Z",
    fill: "#02247D"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M550.628 230.052C550.166 230.052 549.701 230.01 549.237 229.925C547.235 229.558 545.497 228.433 544.341 226.759C543.186 225.083 542.751 223.059 543.118 221.058C543.485 219.056 544.61 217.318 546.284 216.162L552.693 211.741C554.367 210.586 556.396 210.151 558.392 210.518C560.394 210.885 562.132 212.009 563.288 213.684C564.443 215.359 564.877 217.383 564.511 219.385C564.144 221.386 563.019 223.125 561.345 224.281L554.936 228.702C553.652 229.59 552.158 230.052 550.628 230.052ZM557.008 212.392C555.88 212.392 554.779 212.733 553.83 213.388L547.421 217.809C546.187 218.661 545.358 219.943 545.086 221.418C544.815 222.895 545.136 224.388 545.988 225.622C546.84 226.857 548.122 227.686 549.597 227.958C551.075 228.227 552.566 227.908 553.801 227.056L560.21 222.635C561.444 221.783 562.273 220.501 562.544 219.025C562.815 217.549 562.495 216.056 561.643 214.822C560.79 213.587 559.508 212.757 558.033 212.486C557.692 212.423 557.349 212.392 557.008 212.392Z",
    fill: "url(#paint155_linear)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M534.224 240.233C537.807 240.233 540.711 237.329 540.711 233.746C540.711 230.163 537.807 227.259 534.224 227.259C530.641 227.259 527.737 230.163 527.737 233.746C527.737 237.329 530.641 240.233 534.224 240.233Z",
    fill: "url(#paint156_linear)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M548.552 254.309C557.721 245.873 559.518 231.762 552.239 221.213C544.962 210.664 531.131 207.336 519.99 212.912L548.552 254.309Z",
    fill: "#02247D"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M548.552 255.309C548.515 255.309 548.478 255.307 548.441 255.303C548.153 255.271 547.894 255.115 547.729 254.877L519.167 213.481C519.003 213.242 518.95 212.944 519.021 212.664C519.093 212.384 519.283 212.148 519.542 212.018C531.222 206.173 545.635 209.877 553.062 220.645C560.491 231.412 558.843 246.2 549.229 255.045C549.043 255.215 548.801 255.309 548.552 255.309ZM521.482 213.315L548.706 252.771C556.848 244.528 558.061 231.413 551.415 221.781C544.772 212.149 532.079 208.628 521.482 213.315Z",
    fill: "url(#paint157_linear)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M588.499 339.313C588.042 334.145 579.199 330.023 568.353 330.023C557.507 330.023 548.665 334.145 548.207 339.313H588.499Z",
    fill: "#02247D"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M588.499 340.313H548.208C547.928 340.313 547.66 340.195 547.471 339.988C547.282 339.782 547.188 339.505 547.212 339.225C547.727 333.409 556.816 329.023 568.354 329.023C579.892 329.023 588.981 333.409 589.496 339.225C589.52 339.504 589.427 339.782 589.237 339.988C589.047 340.195 588.78 340.313 588.499 340.313ZM549.455 338.313H587.252C585.713 334.206 577.693 331.023 568.354 331.023C559.015 331.023 550.994 334.205 549.455 338.313Z",
    fill: "url(#paint158_linear)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M377.496 283.741C377.496 288.046 380.997 291.547 385.301 291.547V295.623C385.301 296.559 386.06 297.318 386.996 297.318H401.206C402.141 297.318 402.901 296.558 402.901 295.623V273.889C402.901 272.953 402.141 272.194 401.206 272.194H386.996C386.06 272.194 385.301 272.954 385.301 273.889V275.936C380.997 275.936 377.496 279.436 377.496 283.741ZM380.799 283.741C380.799 281.258 382.818 279.238 385.301 279.238V288.244C382.818 288.244 380.799 286.225 380.799 283.741Z",
    fill: "#FF8638"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M382.46 258.184H397.985C399.741 258.184 401.177 256.747 401.177 254.992C401.177 253.236 399.74 251.8 397.985 251.8H382.46C380.704 251.8 379.268 253.237 379.268 254.992C379.267 256.747 380.704 258.184 382.46 258.184Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M378.536 270.601H403.243C404.999 270.601 406.435 269.164 406.435 267.409C406.435 265.653 404.998 264.216 403.243 264.216H378.536C376.78 264.216 375.343 265.654 375.343 267.409C375.343 269.164 376.78 270.601 378.536 270.601Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M386.102 261.567V260.84C386.102 259.283 384.829 258.01 383.273 258.01H396.115C394.559 258.01 393.286 259.283 393.286 260.84V261.567C393.286 263.123 394.559 264.395 396.115 264.395H383.273C384.828 264.395 386.102 263.122 386.102 261.567Z",
    fill: "white"
  }))))))), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M649.958 445.522C648.366 445.522 647.071 444.227 647.071 442.633V370.529C647.071 368.937 648.366 367.642 649.958 367.642C651.551 367.642 652.846 368.937 652.846 370.529V442.633C652.846 444.227 651.551 445.522 649.958 445.522Z",
    fill: "#02247D"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M649.958 446.522C647.814 446.522 646.071 444.778 646.071 442.634V370.529C646.071 368.385 647.814 366.642 649.958 366.642C652.102 366.642 653.846 368.385 653.846 370.529V442.634C653.846 444.778 652.102 446.522 649.958 446.522ZM649.958 368.642C648.918 368.642 648.071 369.489 648.071 370.529V442.634C648.071 443.675 648.918 444.522 649.958 444.522C650.999 444.522 651.846 443.675 651.846 442.634V370.529C651.846 369.489 650.999 368.642 649.958 368.642Z",
    fill: "url(#paint159_linear)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M661.203 468.202H638.713L630.26 442.8H669.657L661.203 468.202Z",
    fill: "#02247D"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M661.203 469.202H638.713C638.282 469.202 637.9 468.927 637.764 468.517L629.311 443.115C629.209 442.81 629.261 442.475 629.449 442.215C629.637 441.954 629.939 441.8 630.261 441.8H669.658C669.979 441.8 670.281 441.954 670.47 442.215C670.658 442.476 670.709 442.811 670.608 443.115L662.154 468.517C662.016 468.927 661.634 469.202 661.203 469.202ZM639.434 467.202H660.483L668.271 443.8H631.647L639.434 467.202Z",
    fill: "url(#paint160_linear)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M654.361 354.139C654.361 360.661 652.39 365.95 649.959 365.95C647.528 365.95 645.558 360.662 645.558 354.139C645.558 347.616 649.959 337.946 649.959 337.946C649.959 337.946 654.361 347.616 654.361 354.139Z",
    fill: "#02247D"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M649.958 366.949C646.412 366.949 644.557 360.505 644.557 354.138C644.557 347.475 648.865 337.933 649.048 337.531C649.21 337.175 649.567 336.945 649.958 336.945C650.349 336.945 650.706 337.174 650.868 337.531C651.052 337.933 655.36 347.475 655.36 354.138C655.361 360.505 653.505 366.949 649.958 366.949ZM649.958 340.532C648.693 343.712 646.557 349.734 646.557 354.139C646.557 360.739 648.572 364.95 649.958 364.95C651.346 364.95 653.36 360.739 653.36 354.139C653.361 349.73 651.224 343.709 649.958 340.532Z",
    fill: "url(#paint161_linear)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M643.589 373.914C647.314 377.64 649.207 381.784 647.819 383.173C646.43 384.561 642.286 382.667 638.561 378.943C634.836 375.219 631.828 367.182 631.828 367.182C631.828 367.182 639.864 370.191 643.589 373.914Z",
    fill: "#02247D"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M646.53 384.632C644.096 384.632 640.648 382.443 637.855 379.65C634.021 375.816 631.018 367.87 630.892 367.533C630.754 367.166 630.844 366.753 631.121 366.475C631.397 366.197 631.812 366.107 632.179 366.246C632.516 366.372 640.462 369.375 644.296 373.209C647.999 376.912 650.641 381.767 648.526 383.881C648.007 384.4 647.321 384.632 646.53 384.632ZM633.676 369.03C634.819 371.625 636.915 375.883 639.269 378.236C643.177 382.144 646.505 383.079 647.113 382.466C647.726 381.853 646.789 378.528 642.883 374.622C640.526 372.266 636.27 370.171 633.676 369.03Z",
    fill: "url(#paint162_linear)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M641.448 390.042C646.92 395.514 649.702 401.604 647.663 403.643C645.623 405.683 639.534 402.901 634.061 397.428C628.589 391.956 624.169 380.15 624.169 380.15C624.169 380.15 635.976 384.571 641.448 390.042Z",
    fill: "#02247D"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M645.774 405.313C642.348 405.313 637.302 402.084 633.355 398.135C627.793 392.573 623.417 380.99 623.234 380.5C623.096 380.133 623.186 379.72 623.463 379.442C623.74 379.164 624.154 379.073 624.521 379.213C625.011 379.397 636.594 383.774 642.156 389.335C644.885 392.064 647.06 395.039 648.282 397.714C649.642 400.691 649.674 403.047 648.371 404.35C647.705 405.016 646.814 405.313 645.774 405.313ZM625.986 381.965C627.523 385.588 630.907 392.858 634.769 396.721C640.47 402.422 645.709 404.187 646.957 402.936C648.204 401.689 646.442 396.45 640.742 390.749C636.878 386.887 629.609 383.503 625.986 381.965Z",
    fill: "url(#paint163_linear)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M639.504 410.828C646.741 418.066 650.422 426.119 647.724 428.816C645.027 431.514 636.973 427.834 629.736 420.597C622.499 413.359 616.652 397.743 616.652 397.743C616.652 397.743 632.267 403.592 639.504 410.828Z",
    fill: "#02247D"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M645.19 430.724C640.784 430.724 634.198 426.473 629.029 421.304C621.722 413.997 615.958 398.741 615.716 398.096C615.578 397.729 615.668 397.316 615.945 397.038C616.222 396.76 616.636 396.669 617.003 396.809C617.649 397.051 632.905 402.815 640.212 410.122C646.907 416.817 652.064 425.893 648.432 429.525C647.603 430.353 646.491 430.724 645.19 430.724ZM618.449 399.543C620.319 404.039 625.021 414.468 630.442 419.89C637.748 427.196 645.039 430.09 647.016 428.111C648.992 426.135 646.102 418.841 638.796 411.536C633.372 406.111 622.946 401.412 618.449 399.543Z",
    fill: "url(#paint164_linear)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M656.328 373.914C652.603 377.64 650.709 381.784 652.098 383.173C653.486 384.561 657.631 382.667 661.356 378.943C665.081 375.219 668.089 367.182 668.089 367.182C668.089 367.182 660.053 370.191 656.328 373.914Z",
    fill: "#02247D"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M653.388 384.632C652.595 384.632 651.91 384.4 651.391 383.88C649.277 381.766 651.918 376.911 655.621 373.208C659.455 369.374 667.401 366.371 667.738 366.245C668.104 366.106 668.518 366.196 668.796 366.474C669.073 366.751 669.163 367.164 669.025 367.532C668.899 367.869 665.896 375.815 662.062 379.649C659.27 382.443 655.821 384.632 653.388 384.632ZM666.241 369.03C663.646 370.173 659.388 372.269 657.035 374.623C653.129 378.529 652.191 381.853 652.805 382.467C653.42 383.079 656.743 382.142 660.649 378.237C663.005 375.879 665.1 371.623 666.241 369.03Z",
    fill: "url(#paint165_linear)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M658.469 390.042C652.997 395.514 650.214 401.604 652.254 403.643C654.293 405.683 660.383 402.901 665.855 397.428C671.328 391.956 675.748 380.15 675.748 380.15C675.748 380.15 663.941 384.571 658.469 390.042Z",
    fill: "#02247D"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M654.162 405.305C653.072 405.305 652.183 404.987 651.547 404.35C650.243 403.047 650.275 400.691 651.635 397.714C652.858 395.039 655.033 392.064 657.762 389.335C663.323 383.773 674.907 379.397 675.397 379.213C675.763 379.073 676.178 379.164 676.455 379.442C676.732 379.719 676.822 380.132 676.684 380.5C676.5 380.99 672.124 392.574 666.562 398.135C663.833 400.864 660.858 403.04 658.183 404.262C656.661 404.957 655.302 405.305 654.162 405.305ZM673.932 381.965C670.31 383.502 663.039 386.886 659.176 390.749C656.612 393.313 654.579 396.082 653.454 398.545C652.509 400.612 652.32 402.295 652.961 402.936C653.603 403.578 655.284 403.389 657.352 402.443C659.815 401.318 662.583 399.286 665.148 396.721C669.015 392.855 672.396 385.587 673.932 381.965Z",
    fill: "url(#paint166_linear)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M660.413 410.828C653.176 418.066 649.495 426.119 652.192 428.816C654.89 431.514 662.944 427.834 670.181 420.597C677.418 413.359 683.264 397.743 683.264 397.743C683.264 397.743 667.651 403.592 660.413 410.828Z",
    fill: "#02247D"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M654.727 430.724C653.425 430.724 652.314 430.353 651.486 429.525C647.855 425.892 653.011 416.817 659.707 410.122C667.014 402.815 682.27 397.052 682.915 396.809C683.282 396.669 683.696 396.76 683.973 397.038C684.25 397.315 684.34 397.728 684.202 398.096C683.96 398.742 678.196 413.997 670.889 421.304C665.721 426.472 659.134 430.724 654.727 430.724ZM681.467 399.543C676.971 401.413 666.542 406.114 661.12 411.535C653.814 418.841 650.924 426.134 652.899 428.11C654.878 430.083 662.169 427.194 669.474 419.889C674.896 414.468 679.597 404.039 681.467 399.543Z",
    fill: "url(#paint167_linear)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M685.917 289.28H667.894L663.138 270.035H690.673L685.917 289.28Z",
    fill: "#02247D"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M685.917 290.28H667.894C667.434 290.28 667.034 289.967 666.923 289.52L662.167 270.275C662.093 269.976 662.161 269.661 662.351 269.419C662.541 269.177 662.83 269.035 663.138 269.035H690.673C690.981 269.035 691.271 269.177 691.46 269.419C691.649 269.661 691.718 269.977 691.644 270.275L686.888 289.52C686.778 289.966 686.377 290.28 685.917 290.28ZM668.677 288.28H685.134L689.396 271.035H664.416L668.677 288.28Z",
    fill: "url(#paint168_linear)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M678.986 270.035H674.826V217.67C674.826 216.522 675.758 215.59 676.906 215.59C678.055 215.59 678.986 216.522 678.986 217.67V270.035Z",
    fill: "#02247D"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M678.986 271.034H674.826C674.273 271.034 673.826 270.587 673.826 270.034V217.671C673.826 215.973 675.208 214.591 676.906 214.591C678.604 214.591 679.986 215.973 679.986 217.671V270.034C679.986 270.587 679.538 271.034 678.986 271.034ZM675.825 269.034H677.985V217.671C677.985 217.075 677.501 216.591 676.905 216.591C676.309 216.591 675.825 217.075 675.825 217.671V269.034Z",
    fill: "url(#paint169_linear)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M692.533 269.44H661.28V275.83H692.533V269.44Z",
    fill: "#02247D"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M692.532 276.829H661.279C660.726 276.829 660.279 276.382 660.279 275.829V269.439C660.279 268.886 660.726 268.439 661.279 268.439H692.532C693.085 268.439 693.532 268.886 693.532 269.439V275.829C693.532 276.382 693.085 276.829 692.532 276.829ZM662.28 274.829H691.533V270.439H662.28V274.829Z",
    fill: "url(#paint170_linear)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M678.443 251.11L682.158 252.401C683.801 252.972 685.596 252.104 686.168 250.461C686.739 248.818 685.87 247.023 684.228 246.451L683.039 246.04C681.395 245.466 679.601 246.335 679.029 247.978L678.151 250.504C678.064 250.751 678.195 251.023 678.443 251.11Z",
    fill: "url(#paint171_linear)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M683.195 253.577C682.736 253.577 682.276 253.5 681.83 253.345L678.112 252.053C677.346 251.785 676.939 250.943 677.205 250.176L678.084 247.65C678.448 246.602 679.198 245.76 680.195 245.277C681.193 244.795 682.319 244.73 683.367 245.094L684.554 245.506C685.602 245.869 686.445 246.62 686.928 247.617C687.411 248.615 687.477 249.741 687.113 250.788C686.749 251.835 685.999 252.678 685.001 253.16C684.427 253.438 683.813 253.577 683.195 253.577ZM679.266 250.337L682.486 251.456C683.027 251.643 683.611 251.61 684.129 251.36C684.647 251.11 685.035 250.673 685.224 250.131C685.412 249.588 685.378 249.005 685.128 248.488C684.877 247.97 684.44 247.582 683.899 247.393L682.711 246.981C682.166 246.793 681.582 246.825 681.066 247.076C680.549 247.326 680.161 247.763 679.972 248.305L679.266 250.337Z",
    fill: "url(#paint172_linear)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M668.798 255.807L666.858 256.483C664.18 257.415 662.762 260.344 663.694 263.025C664.627 265.706 667.555 267.124 670.237 266.192L676.296 264.083C676.703 263.944 676.915 263.5 676.776 263.097L675.341 258.976C674.408 256.293 671.479 254.875 668.798 255.807Z",
    fill: "url(#paint173_linear)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M668.555 267.477C666.013 267.477 663.63 265.885 662.749 263.353C661.638 260.156 663.333 256.65 666.529 255.539L668.469 254.863C671.663 253.746 675.172 255.448 676.284 258.646L677.719 262.767C677.875 263.221 677.845 263.705 677.636 264.131C677.427 264.557 677.065 264.875 676.616 265.027L670.564 267.135C669.901 267.367 669.222 267.477 668.555 267.477ZM669.127 256.751L667.187 257.427C665.032 258.177 663.889 260.54 664.638 262.697C665.387 264.851 667.753 265.995 669.909 265.248L675.757 263.211L674.398 259.304C673.647 257.147 671.284 256.001 669.127 256.751Z",
    fill: "url(#paint174_linear)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M671.4 240.742L670.211 241.156C668.568 241.727 667.699 243.523 668.271 245.166C668.843 246.809 670.637 247.678 672.281 247.106L675.996 245.813C676.243 245.728 676.375 245.457 676.289 245.209L675.409 242.684C674.836 241.041 673.042 240.172 671.4 240.742Z",
    fill: "#02247D"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M671.249 248.282C669.53 248.282 667.92 247.207 667.325 245.495C666.961 244.449 667.026 243.322 667.51 242.325C667.992 241.327 668.835 240.577 669.882 240.213L671.07 239.799H671.071C672.117 239.436 673.244 239.501 674.241 239.984C675.238 240.467 675.988 241.31 676.351 242.357L677.231 244.881C677.361 245.256 677.336 245.656 677.164 246.012C676.991 246.366 676.691 246.632 676.319 246.76L672.608 248.052C672.158 248.207 671.699 248.282 671.249 248.282ZM671.729 241.687L670.54 242.101C669.42 242.491 668.825 243.718 669.215 244.838C669.605 245.957 670.83 246.556 671.952 246.162L675.171 245.042L674.464 243.013C674.276 242.469 673.887 242.033 673.37 241.783C672.855 241.532 672.27 241.498 671.729 241.687Z",
    fill: "url(#paint175_linear)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M685.74 255.824L684.519 254.922C682.83 253.678 680.455 254.035 679.208 255.723L677.294 258.317C677.106 258.571 677.16 258.93 677.415 259.118L681.228 261.934C682.916 263.18 685.294 262.821 686.539 261.135C687.786 259.448 687.428 257.071 685.74 255.824Z",
    fill: "#02247D"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M683.476 263.677C682.458 263.677 681.47 263.354 680.636 262.739L676.823 259.923C676.485 259.675 676.264 259.308 676.201 258.892C676.138 258.477 676.242 258.062 676.492 257.723L678.405 255.131C679.975 253.003 682.985 252.548 685.113 254.118L686.335 255.019C686.335 255.019 686.335 255.019 686.336 255.019C688.464 256.591 688.917 259.602 687.346 261.729C686.585 262.759 685.469 263.432 684.201 263.624C683.958 263.659 683.716 263.677 683.476 263.677ZM678.354 258.567L681.824 261.13C682.426 261.574 683.167 261.754 683.903 261.647C684.642 261.536 685.293 261.143 685.736 260.543C686.652 259.302 686.388 257.547 685.147 256.63L683.926 255.729C682.683 254.815 680.93 255.081 680.014 256.32L678.354 258.567Z",
    fill: "url(#paint176_linear)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M678.443 229.957L682.158 231.249C683.801 231.82 685.596 230.951 686.168 229.309C686.74 227.667 685.87 225.871 684.228 225.299L683.039 224.887C681.395 224.315 679.601 225.183 679.029 226.826L678.151 229.351C678.064 229.6 678.195 229.871 678.443 229.957Z",
    fill: "url(#paint177_linear)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M683.195 232.426C682.736 232.426 682.276 232.349 681.83 232.194L678.115 230.902C677.742 230.773 677.443 230.506 677.271 230.151C677.099 229.797 677.077 229.397 677.205 229.025L678.084 226.499C678.448 225.451 679.198 224.608 680.196 224.125C681.195 223.644 682.32 223.578 683.367 223.943L684.554 224.355C685.603 224.719 686.446 225.468 686.928 226.466C687.411 227.464 687.477 228.59 687.113 229.637C686.749 230.684 685.999 231.527 685.001 232.009C684.427 232.286 683.813 232.426 683.195 232.426ZM679.266 229.185L682.486 230.305C683.027 230.492 683.611 230.459 684.129 230.209C684.647 229.959 685.035 229.522 685.224 228.98C685.412 228.437 685.378 227.854 685.128 227.337C684.878 226.819 684.44 226.431 683.899 226.242L682.711 225.83C682.165 225.641 681.583 225.674 681.067 225.924C680.549 226.174 680.161 226.611 679.972 227.153L679.266 229.185Z",
    fill: "url(#paint178_linear)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M672.399 232.879L671.687 233.127C670.706 233.468 670.186 234.541 670.528 235.524C670.87 236.507 671.943 237.027 672.926 236.685L675.147 235.912C675.296 235.861 675.374 235.698 675.323 235.551L674.798 234.039C674.455 233.057 673.381 232.537 672.399 232.879Z",
    fill: "url(#paint179_linear)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M672.312 237.789C671.117 237.789 669.997 237.042 669.583 235.852C669.061 234.351 669.856 232.704 671.357 232.181L672.07 231.934C672.798 231.68 673.579 231.726 674.273 232.062C674.966 232.398 675.488 232.983 675.741 233.711L676.266 235.222C676.379 235.55 676.358 235.9 676.206 236.209C676.055 236.517 675.792 236.747 675.468 236.858L673.254 237.629C672.943 237.739 672.624 237.789 672.312 237.789ZM673.018 233.774C672.92 233.774 672.823 233.791 672.727 233.824L672.015 234.071C671.556 234.231 671.312 234.736 671.472 235.197C671.632 235.658 672.14 235.901 672.599 235.741L674.143 235.204L673.853 234.369C673.775 234.146 673.616 233.967 673.403 233.863C673.28 233.804 673.15 233.774 673.018 233.774Z",
    fill: "url(#paint180_linear)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M671.4 219.591L670.211 220.005C668.568 220.576 667.699 222.371 668.271 224.014C668.842 225.658 670.637 226.527 672.281 225.955L675.996 224.662C676.243 224.576 676.375 224.305 676.289 224.058L675.409 221.532C674.836 219.889 673.042 219.02 671.4 219.591Z",
    fill: "#02247D"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M671.241 227.132C670.624 227.132 670.009 226.992 669.436 226.715C668.438 226.233 667.689 225.39 667.325 224.342C666.961 223.296 667.026 222.17 667.51 221.172C667.992 220.174 668.835 219.425 669.882 219.061L671.07 218.647H671.071C672.117 218.284 673.243 218.348 674.241 218.832C675.238 219.314 675.987 220.157 676.351 221.204L677.231 223.729C677.361 224.102 677.337 224.503 677.165 224.859C676.993 225.215 676.691 225.48 676.319 225.608L672.608 226.9C672.161 227.055 671.7 227.132 671.241 227.132ZM671.729 220.535L670.54 220.949C669.42 221.339 668.826 222.566 669.215 223.685C669.403 224.227 669.792 224.664 670.31 224.914C670.827 225.165 671.411 225.199 671.953 225.01L675.172 223.89L674.465 221.86C674.277 221.317 673.888 220.881 673.371 220.631C672.855 220.381 672.27 220.347 671.729 220.535Z",
    fill: "url(#paint181_linear)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M685.142 235.116L684.129 234.369C682.729 233.337 680.759 233.633 679.725 235.033L678.138 237.183C677.982 237.394 678.027 237.692 678.238 237.847L681.401 240.183C682.801 241.216 684.774 240.919 685.805 239.52C686.839 238.121 686.541 236.151 685.142 235.116Z",
    fill: "#02247D"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M683.264 241.8C682.384 241.8 681.53 241.521 680.807 240.988L677.644 238.653C676.989 238.168 676.85 237.242 677.334 236.588L678.92 234.44C680.276 232.601 682.88 232.208 684.722 233.563L685.736 234.312H685.737C686.629 234.971 687.21 235.938 687.376 237.034C687.541 238.13 687.269 239.224 686.609 240.116C685.953 241.007 684.987 241.589 683.891 241.754C683.681 241.784 683.472 241.8 683.264 241.8ZM679.254 237.356L681.994 239.379C682.457 239.721 683.028 239.863 683.593 239.775C684.16 239.69 684.659 239.388 685 238.927C685.342 238.464 685.482 237.898 685.396 237.33C685.311 236.762 685.009 236.262 684.547 235.92L683.534 235.172C682.582 234.471 681.232 234.673 680.528 235.626L679.254 237.356Z",
    fill: "url(#paint182_linear)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M381.115 293.201C385.089 287.043 382.758 279.67 383.23 278.897C383.348 278.705 383.341 278.364 384.183 278.543C386.574 279.052 388.355 286.753 388.537 288.153C391.286 286.639 392.163 286.225 395.05 284.219C399.431 281.176 406.075 279.484 406.689 285.082C407.13 289.107 406.739 289.959 398.192 295.098C396.894 295.879 390.647 298.829 387.775 300.684L381.115 293.201Z",
    fill: "url(#paint183_linear)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M305.609 215.498H292.932C285.566 215.498 279.595 221.47 279.595 228.836V254.94C279.595 261.971 282.286 262.786 287.546 266.365C287.862 268.991 287.43 273.297 286.337 275.022C284.913 277.269 306.207 280.042 304.957 276.333C304.153 273.948 304.145 268.917 306.54 268.917C314.417 268.917 319.411 262.19 320.165 254.722C321.604 240.462 319.019 230.992 318.947 228.837C318.702 221.474 312.975 215.498 305.609 215.498Z",
    fill: "url(#paint184_linear)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M319.631 219.119C314.784 211.965 307.127 207.849 298.622 207.83L296.154 207.824C282.261 207.824 270.963 219.127 270.898 233.021C270.892 234.281 270.864 236.06 270.876 243.482C270.88 246.021 271.999 250.663 273.956 254.822C276.18 259.549 281.657 265.398 287.789 265.398C295.039 265.398 301.595 257.659 303.519 252.883C305.233 248.628 304.857 242.982 304.857 235.87C315.123 236.397 317.439 234.634 319.414 232.456C322.464 229.096 322.382 223.182 319.631 219.119Z",
    fill: "#02247D"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M287.789 266.399C280.825 266.399 275.16 259.731 273.051 255.249C271.186 251.284 269.88 246.447 269.876 243.485C269.866 237.355 269.883 235.07 269.893 233.751L269.898 233.018C269.966 218.576 281.745 206.826 296.154 206.826L298.625 206.832C307.465 206.853 315.424 211.127 320.459 218.561C323.554 223.132 323.42 229.532 320.155 233.131C318.007 235.5 315.563 237.295 305.86 236.92C305.863 237.67 305.87 238.403 305.876 239.119C305.926 244.914 305.965 249.491 304.447 253.26C302.6 257.84 295.819 266.399 287.789 266.399ZM296.152 208.824C282.842 208.824 271.961 219.681 271.898 233.026L271.893 233.764C271.883 235.081 271.866 237.362 271.876 243.48C271.879 245.759 272.906 250.24 274.861 254.396C277.143 259.245 282.449 264.398 287.79 264.398C294.237 264.398 300.634 257.369 302.592 252.509C303.962 249.11 303.924 244.707 303.876 239.134C303.867 238.082 303.857 236.995 303.857 235.871C303.857 235.597 303.969 235.335 304.168 235.146C304.367 234.957 304.636 234.854 304.908 234.872C315.387 235.411 317.132 233.484 318.673 231.784C321.302 228.887 321.36 223.456 318.802 219.679C314.144 212.803 306.787 208.848 298.619 208.829L296.152 208.824Z",
    fill: "url(#paint185_linear)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M391.315 302.766C389.024 306.695 364.793 322.895 355.26 329.829C352.492 331.843 344.335 332.827 341.555 330.827C331.316 323.461 306.956 304.97 305.852 295.362C305.46 291.956 308.833 277.147 312.441 279.075C325.94 286.282 347.909 313.655 347.909 313.655C347.909 313.655 369.324 298.464 381.198 292.635C385.629 290.459 394.004 298.152 391.315 302.766Z",
    fill: "#02247D"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M346.617 332.933C344.332 332.933 342.224 332.54 340.971 331.638C335.88 327.975 326.141 320.726 318.126 313.328L319.482 311.857C327.42 319.183 337.085 326.378 342.139 330.014C344.507 331.716 352.166 330.841 354.672 329.019C357.057 327.284 360.427 324.923 363.995 322.424C373.89 315.493 388.842 305.02 390.451 302.26C391.515 300.434 390.228 297.992 388.668 296.317C386.397 293.877 383.375 292.679 381.637 293.532C369.972 299.258 348.7 314.318 348.487 314.47C348.056 314.777 347.461 314.694 347.129 314.281C346.91 314.009 325.133 286.986 311.97 279.956L312.912 278.192C325.358 284.838 344.432 307.804 348.097 312.299C352.04 309.533 370.218 296.91 380.757 291.737C383.766 290.258 387.727 292.37 390.132 294.955C392.746 297.764 393.53 300.949 392.178 303.268C390.483 306.175 379.424 314.059 365.142 324.063C361.581 326.556 358.219 328.912 355.848 330.636C353.926 332.035 350.07 332.933 346.617 332.933Z",
    fill: "url(#paint186_linear)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M551.547 187.492V187.34C551.547 186.88 551.682 186.444 551.938 186.076C552.237 185.649 552.678 185.344 553.176 185.212L563.098 178.313C564.106 177.623 565.481 177.873 566.169 178.866C566.839 179.842 566.573 181.268 565.613 181.93L557.721 187.416L565.616 192.904C566.572 193.562 566.837 194.994 566.172 195.963C565.48 196.964 564.103 197.213 563.101 196.521L553.178 189.622C552.678 189.491 552.236 189.184 551.937 188.755C551.681 188.385 551.547 187.949 551.547 187.492ZM553.547 187.471L552.547 187.492H553.547C553.547 187.556 553.565 187.592 553.58 187.614C553.61 187.657 553.653 187.683 553.708 187.691L553.95 187.722L564.24 194.876C564.333 194.94 564.462 194.919 564.525 194.827C564.565 194.767 564.654 194.667 564.477 194.548L554.217 187.415L564.474 180.285C564.656 180.159 564.566 180.063 564.523 180.001C564.461 179.911 564.331 179.891 564.234 179.957L553.953 187.106L553.714 187.139C553.674 187.144 553.617 187.162 553.577 187.219C553.57 187.229 553.547 187.264 553.547 187.338V187.471Z",
    fill: "url(#paint187_linear)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M562.343 187.498V187.334C562.343 186.878 562.479 186.443 562.735 186.076C563.035 185.649 563.477 185.345 563.975 185.212L573.897 178.313C574.9 177.622 576.273 177.872 576.962 178.866C577.632 179.821 577.376 181.263 576.413 181.93L568.515 187.416L576.414 192.904C577.377 193.568 577.636 195.006 576.96 195.97C576.628 196.449 576.126 196.773 575.547 196.878C574.968 196.982 574.382 196.855 573.898 196.519L563.977 189.621C563.477 189.49 563.035 189.183 562.735 188.756C562.478 188.384 562.343 187.95 562.343 187.498ZM564.344 187.479L563.343 187.499H564.343C564.343 187.559 564.362 187.593 564.377 187.615C564.417 187.672 564.476 187.688 564.508 187.692L564.749 187.723L575.039 194.877C575.097 194.916 575.153 194.917 575.19 194.91C575.227 194.904 575.279 194.884 575.318 194.828C575.367 194.758 575.449 194.668 575.274 194.547L565.008 187.416L575.273 180.286C575.448 180.164 575.364 180.07 575.321 180.009C575.256 179.914 575.128 179.893 575.035 179.957L564.752 187.107L564.514 187.139C564.48 187.144 564.416 187.161 564.373 187.222C564.367 187.231 564.343 187.265 564.343 187.333L564.344 187.479Z",
    fill: "url(#paint188_linear)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M573.14 187.042V186.867C573.14 186.41 573.276 185.976 573.533 185.611C573.824 185.189 574.266 184.882 574.769 184.748L584.688 177.85C585.702 177.162 587.077 177.414 587.761 178.407C588.428 179.362 588.169 180.801 587.207 181.469L579.311 186.956L587.207 192.44C588.168 193.106 588.43 194.538 587.76 195.504C587.071 196.502 585.694 196.75 584.691 196.059L574.769 189.159C574.264 189.024 573.821 188.717 573.527 188.288C573.276 187.93 573.14 187.496 573.14 187.042ZM575.141 187.022L574.14 187.043H575.14C575.14 187.099 575.156 187.129 575.169 187.148C575.21 187.208 575.268 187.225 575.309 187.231L575.547 187.264L585.83 194.414C585.924 194.479 586.051 194.459 586.115 194.366C586.158 194.303 586.243 194.206 586.066 194.083L575.805 186.955L586.066 179.825C586.243 179.703 586.158 179.605 586.116 179.545C586.05 179.449 585.921 179.43 585.82 179.498L575.547 186.643L575.309 186.676C575.276 186.68 575.213 186.697 575.174 186.754C575.155 186.779 575.14 186.81 575.14 186.867L575.141 187.022Z",
    fill: "url(#paint189_linear)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M583.937 187.045V186.863C583.937 186.42 584.068 185.992 584.317 185.625C584.624 185.189 585.065 184.883 585.562 184.749L595.49 177.85C596.492 177.161 597.866 177.411 598.557 178.404C599.226 179.368 598.965 180.802 598.002 181.469L590.108 186.955L598.003 192.439C598.965 193.105 599.228 194.539 598.558 195.503C598.22 195.988 597.716 196.312 597.137 196.415C596.557 196.52 595.971 196.392 595.488 196.054L585.562 189.158C585.064 189.024 584.623 188.719 584.326 188.295C584.068 187.914 583.937 187.487 583.937 187.045ZM585.937 187.03L584.937 187.046H585.937C585.937 187.088 585.949 187.126 585.973 187.163C585.996 187.196 586.043 187.224 586.104 187.231L586.341 187.264L596.63 194.414C596.711 194.471 596.86 194.441 596.915 194.363C596.954 194.306 597.042 194.207 596.863 194.084L586.602 186.955L596.862 179.825C597.043 179.7 596.955 179.604 596.914 179.545C596.85 179.452 596.721 179.43 596.626 179.494L586.341 186.642L586.104 186.675C586.063 186.681 586.005 186.7 585.963 186.76C585.948 186.782 585.937 186.82 585.937 186.863V187.03Z",
    fill: "url(#paint190_linear)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M331.998 158.854V159.004C331.998 159.465 331.863 159.902 331.607 160.269C331.308 160.696 330.867 161 330.369 161.133L320.447 168.033C319.439 168.722 318.064 168.472 317.376 167.479C316.706 166.503 316.972 165.078 317.932 164.414L325.824 158.929L317.929 153.442C316.973 152.783 316.708 151.35 317.373 150.381C318.065 149.381 319.442 149.132 320.444 149.824L330.367 156.723C330.867 156.855 331.309 157.161 331.608 157.59C331.864 157.961 331.998 158.397 331.998 158.854ZM329.998 158.873L330.998 158.853H329.998C329.998 158.787 329.98 158.752 329.965 158.73C329.935 158.687 329.892 158.661 329.837 158.654L329.595 158.623L319.305 151.468C319.212 151.405 319.083 151.426 319.02 151.518C318.98 151.577 318.891 151.676 319.068 151.797L329.328 158.929L319.071 166.059C318.889 166.184 318.979 166.282 319.022 166.343C319.084 166.432 319.214 166.453 319.311 166.387L329.592 159.237L329.831 159.206C329.871 159.2 329.928 159.182 329.968 159.124C329.975 159.114 329.998 159.081 329.998 159.005V158.873Z",
    fill: "url(#paint191_linear)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M321.202 158.847V159.011C321.202 159.467 321.066 159.903 320.81 160.269C320.51 160.696 320.068 161 319.57 161.133L309.648 168.033C308.645 168.722 307.272 168.473 306.583 167.479C305.913 166.524 306.169 165.082 307.132 164.416L315.03 158.929L307.131 153.442C306.168 152.777 305.909 151.34 306.585 150.376C306.917 149.897 307.419 149.572 307.998 149.468C308.577 149.363 309.163 149.49 309.647 149.827L319.568 156.724C320.068 156.856 320.51 157.162 320.81 157.589C321.067 157.961 321.202 158.395 321.202 158.847ZM319.201 158.866L320.202 158.846H319.202C319.202 158.786 319.183 158.753 319.168 158.73C319.128 158.673 319.069 158.658 319.037 158.654L318.796 158.623L308.506 151.468C308.448 151.428 308.392 151.428 308.355 151.435C308.318 151.442 308.266 151.461 308.227 151.518C308.178 151.587 308.096 151.677 308.271 151.797L318.537 158.929L308.272 166.059C308.097 166.18 308.181 166.275 308.224 166.336C308.289 166.431 308.417 166.453 308.51 166.389L318.793 159.238L319.031 159.206C319.065 159.201 319.129 159.185 319.172 159.122C319.178 159.114 319.202 159.08 319.202 159.012L319.201 158.866Z",
    fill: "url(#paint192_linear)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M310.405 159.303V159.478C310.405 159.934 310.269 160.37 310.012 160.735C309.721 161.157 309.279 161.464 308.776 161.597L298.857 168.494C297.843 169.183 296.468 168.932 295.784 167.938C295.117 166.982 295.376 165.544 296.338 164.876L304.234 159.389L296.338 153.904C295.377 153.239 295.115 151.807 295.785 150.84C296.474 149.844 297.851 149.595 298.854 150.286L308.776 157.186C309.281 157.32 309.724 157.628 310.018 158.056C310.269 158.414 310.405 158.848 310.405 159.303ZM308.404 159.323L309.405 159.303H308.405C308.405 159.246 308.389 159.217 308.376 159.198C308.335 159.138 308.277 159.121 308.236 159.115L307.998 159.083L297.715 151.931C297.621 151.867 297.494 151.887 297.43 151.98C297.387 152.043 297.302 152.14 297.479 152.263L307.74 159.391L297.479 166.521C297.302 166.644 297.387 166.741 297.429 166.801C297.495 166.897 297.624 166.916 297.725 166.848L307.998 159.702L308.236 159.67C308.269 159.665 308.332 159.649 308.371 159.593C308.39 159.566 308.405 159.536 308.405 159.479L308.404 159.323Z",
    fill: "url(#paint193_linear)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M299.608 159.3V159.481C299.608 159.924 299.477 160.354 299.228 160.721C298.921 161.157 298.48 161.463 297.983 161.596L288.055 168.495C287.053 169.184 285.679 168.935 284.988 167.941C284.319 166.976 284.58 165.543 285.543 164.877L293.437 159.39L285.542 153.905C284.58 153.241 284.317 151.807 284.987 150.841C285.325 150.357 285.829 150.033 286.408 149.929C286.988 149.825 287.574 149.952 288.057 150.29L297.983 157.188C298.481 157.321 298.922 157.626 299.219 158.05C299.477 158.431 299.608 158.858 299.608 159.3ZM297.608 159.316L298.608 159.3H297.608C297.608 159.258 297.596 159.22 297.572 159.184C297.549 159.151 297.502 159.123 297.441 159.115L297.204 159.083L286.915 151.932C286.834 151.875 286.685 151.904 286.63 151.983C286.591 152.04 286.503 152.139 286.682 152.263L296.943 159.391L286.683 166.521C286.502 166.646 286.59 166.742 286.631 166.801C286.695 166.894 286.824 166.916 286.919 166.851L297.204 159.703L297.441 159.671C297.482 159.666 297.54 159.647 297.582 159.586C297.597 159.565 297.608 159.525 297.608 159.482V159.316Z",
    fill: "url(#paint194_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 300,
    x2: 899.999,
    y2: 300,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022894"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 126,
    y1: 497.928,
    x2: 774.935,
    y2: 497.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 295.863,
    y1: 490.4,
    x2: 384.06,
    y2: 490.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03BEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#964AE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 231.568,
    y1: 479.351,
    x2: 426.916,
    y2: 479.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03BEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#964AE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 416.788,
    y1: 490.4,
    x2: 446.715,
    y2: 490.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03BEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#964AE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 262.133,
    y1: 490.4,
    x2: 279.866,
    y2: 490.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03BEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#964AE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 696.236,
    y1: 461.852,
    x2: 748.004,
    y2: 461.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03BEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#964AE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 303.789,
    y1: 468.202,
    x2: 338.025,
    y2: 468.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03BEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#964AE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 341.729,
    y1: 468.202,
    x2: 352.138,
    y2: 468.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03BEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#964AE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 601.669,
    y1: 477.926,
    x2: 631.821,
    y2: 477.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03BEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#964AE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 643.01,
    y1: 477.926,
    x2: 653.241,
    y2: 477.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03BEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#964AE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 590.137,
    y1: 477.926,
    x2: 596.199,
    y2: 477.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03BEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#964AE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 498.787,
    y1: 476.926,
    x2: 517.029,
    y2: 476.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03BEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#964AE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 525.664,
    y1: 476.926,
    x2: 533.56,
    y2: 476.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03BEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#964AE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 680.569,
    y1: 477.926,
    x2: 732.421,
    y2: 477.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03BEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#964AE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 177.775,
    y1: 308.762,
    x2: 185.892,
    y2: 308.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    stopColor: "#FA9A35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#F67160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    stopColor: "#F35480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    stopColor: "#F14193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03B9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 196.739,
    y1: 308.757,
    x2: 204.867,
    y2: 308.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    stopColor: "#FA9A35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#F67160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    stopColor: "#F35480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    stopColor: "#F14193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03B9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 186.489,
    y1: 305.159,
    x2: 196.135,
    y2: 305.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    stopColor: "#FA9A35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#F67160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    stopColor: "#F35480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    stopColor: "#F14193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03B9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 186.489,
    y1: 308.756,
    x2: 196.135,
    y2: 308.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    stopColor: "#FA9A35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#F67160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    stopColor: "#F35480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    stopColor: "#F14193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03B9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 186.489,
    y1: 312.354,
    x2: 192.085,
    y2: 312.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    stopColor: "#FA9A35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#F67160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    stopColor: "#F35480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    stopColor: "#F14193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03B9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 371.297,
    y1: 179.92,
    x2: 430.67,
    y2: 179.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#964AE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 370.797,
    y1: 179.92,
    x2: 431.17,
    y2: 179.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 186.034,
    y1: 255.567,
    x2: 242.206,
    y2: 255.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 195.889,
    y1: 248.264,
    x2: 205.717,
    y2: 248.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC20B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F24B89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 223.232,
    y1: 248.351,
    x2: 233.195,
    y2: 248.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC20B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F24B89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 208.157,
    y1: 248.265,
    x2: 221.729,
    y2: 248.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC20B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F24B89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 181.134,
    y1: 193.797,
    x2: 278.134,
    y2: 193.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03B9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 604.346,
    y1: 315.832,
    x2: 701.345,
    y2: 315.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03B9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 620.733,
    y1: 260.087,
    x2: 634.44,
    y2: 260.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 620.747,
    y1: 282.331,
    x2: 634.325,
    y2: 282.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 620.768,
    y1: 276.351,
    x2: 634.347,
    y2: 276.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 632.347,
    y1: 270.708,
    x2: 641.555,
    y2: 270.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 607.771,
    y1: 293.388,
    x2: 700.949,
    y2: 293.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 322.828,
    y1: 185.119,
    x2: 362.828,
    y2: 185.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 643.887,
    y1: 271.037,
    x2: 666.25,
    y2: 271.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 242.601,
    y1: 216.44,
    x2: 264.964,
    y2: 216.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 601.414,
    y1: 224.711,
    x2: 611.554,
    y2: 224.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 685.445,
    y1: 354.841,
    x2: 692.307,
    y2: 354.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 549.117,
    y1: 300.687,
    x2: 555.978,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 242.687,
    y1: 180.464,
    x2: 249.548,
    y2: 180.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 223.801,
    y1: 219.87,
    x2: 230.661,
    y2: 219.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 290.08,
    y1: 188.039,
    x2: 295.51,
    y2: 188.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 292.796,
    y1: 185.324,
    x2: 292.796,
    y2: 190.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: 673.315,
    y1: 325.016,
    x2: 695.678,
    y2: 325.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 594.257,
    y1: 251.344,
    x2: 599.687,
    y2: 251.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: 596.971,
    y1: 248.629,
    x2: 596.971,
    y2: 254.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: 710.307,
    y1: 335.636,
    x2: 670.307,
    y2: 335.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: 636.624,
    y1: 204.283,
    x2: 596.624,
    y2: 204.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: 531.366,
    y1: 189.039,
    x2: 502.315,
    y2: 189.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear",
    x1: 499.288,
    y1: 189.039,
    x2: 491.366,
    y2: 189.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear",
    x1: 357.35,
    y1: 173.02,
    x2: 334.987,
    y2: 173.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear",
    x1: 549.555,
    y1: 167.366,
    x2: 539.415,
    y2: 167.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear",
    x1: 527.419,
    y1: 170.721,
    x2: 520.557,
    y2: 170.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear",
    x1: 334.943,
    y1: 202.853,
    x2: 328.083,
    y2: 202.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear",
    x1: 259.212,
    y1: 262.842,
    x2: 253.782,
    y2: 262.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear",
    x1: 259.212,
    y1: 262.842,
    x2: 253.782,
    y2: 262.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear",
    x1: 256.497,
    y1: 265.557,
    x2: 256.497,
    y2: 260.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear",
    x1: 241.321,
    y1: 146.716,
    x2: 235.891,
    y2: 146.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear",
    x1: 241.321,
    y1: 146.716,
    x2: 235.891,
    y2: 146.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear",
    x1: 238.607,
    y1: 149.431,
    x2: 238.607,
    y2: 144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear",
    x1: 432.286,
    y1: 198.137,
    x2: 403.234,
    y2: 198.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear",
    x1: 400.208,
    y1: 198.137,
    x2: 392.286,
    y2: 198.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear",
    x1: 262.059,
    y1: 286.021,
    x2: 233.008,
    y2: 286.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear",
    x1: 229.981,
    y1: 286.021,
    x2: 222.059,
    y2: 286.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear",
    x1: 211.985,
    y1: 210.539,
    x2: 189.622,
    y2: 210.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear",
    x1: 268.308,
    y1: 165.408,
    x2: 239.257,
    y2: 165.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear",
    x1: 236.229,
    y1: 165.408,
    x2: 228.308,
    y2: 165.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear",
    x1: 385.007,
    y1: 156.585,
    x2: 379.577,
    y2: 156.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear",
    x1: 385.007,
    y1: 156.585,
    x2: 379.577,
    y2: 156.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear",
    x1: 382.291,
    y1: 159.3,
    x2: 382.291,
    y2: 153.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear",
    x1: 460.268,
    y1: 187.834,
    x2: 454.839,
    y2: 187.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear",
    x1: 460.268,
    y1: 187.834,
    x2: 454.839,
    y2: 187.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear",
    x1: 457.553,
    y1: 190.549,
    x2: 457.553,
    y2: 185.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear",
    x1: 444.365,
    y1: 157.585,
    x2: 415.313,
    y2: 157.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear",
    x1: 412.286,
    y1: 157.585,
    x2: 404.365,
    y2: 157.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear",
    x1: 652.673,
    y1: 214.466,
    x2: 647.243,
    y2: 214.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear",
    x1: 652.673,
    y1: 214.466,
    x2: 647.243,
    y2: 214.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear",
    x1: 649.958,
    y1: 217.181,
    x2: 649.958,
    y2: 211.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear",
    x1: 692.36,
    y1: 304.645,
    x2: 686.93,
    y2: 304.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear",
    x1: 689.646,
    y1: 307.36,
    x2: 689.646,
    y2: 301.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0399C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear",
    x1: 515.731,
    y1: 346.877,
    x2: 633.43,
    y2: 346.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#964AE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear",
    x1: 514.731,
    y1: 346.877,
    x2: 634.43,
    y2: 346.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear",
    x1: 182.95,
    y1: 346.878,
    x2: 553.252,
    y2: 346.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear",
    x1: 203.757,
    y1: 413.446,
    x2: 222.983,
    y2: 413.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear",
    x1: 195.144,
    y1: 413.446,
    x2: 214.37,
    y2: 413.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear",
    x1: 539.861,
    y1: 413.446,
    x2: 619.002,
    y2: 413.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#964AE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear",
    x1: 538.861,
    y1: 413.447,
    x2: 620.002,
    y2: 413.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear",
    x1: 427.022,
    y1: 413.447,
    x2: 448.484,
    y2: 413.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear",
    x1: 446.484,
    y1: 413.446,
    x2: 523.636,
    y2: 413.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear",
    x1: 447.484,
    y1: 387.582,
    x2: 522.636,
    y2: 387.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear",
    x1: 447.484,
    y1: 416.332,
    x2: 522.636,
    y2: 416.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear",
    x1: 479.592,
    y1: 401.37,
    x2: 487.694,
    y2: 401.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear",
    x1: 479.592,
    y1: 370.099,
    x2: 487.694,
    y2: 370.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear",
    x1: 485.06,
    y1: 440.282,
    x2: 485.06,
    y2: 448.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#964AE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear",
    x1: 485.06,
    y1: 439.281,
    x2: 485.06,
    y2: 449.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear",
    x1: 521.636,
    y1: 413.446,
    x2: 540.861,
    y2: 413.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear",
    x1: 289.941,
    y1: 407.937,
    x2: 349.509,
    y2: 407.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F03B9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1726,
    stopColor: "#F3557E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7419,
    stopColor: "#FCA925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear",
    x1: 327.138,
    y1: 329.419,
    x2: 353.536,
    y2: 329.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F03B9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1726,
    stopColor: "#F3557E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7419,
    stopColor: "#FCA925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear",
    x1: 289.776,
    y1: 398.308,
    x2: 352.824,
    y2: 398.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear",
    x1: 266.528,
    y1: 309.579,
    x2: 329.714,
    y2: 309.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear",
    x1: 284.727,
    y1: 452.425,
    x2: 330.745,
    y2: 452.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear",
    x1: 406.682,
    y1: 323.055,
    x2: 442.048,
    y2: 323.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear",
    x1: 382.683,
    y1: 336.088,
    x2: 466.047,
    y2: 336.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear",
    x1: 338.595,
    y1: 260.088,
    x2: 510.134,
    y2: 260.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#964AE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear",
    x1: 337.595,
    y1: 260.088,
    x2: 511.134,
    y2: 260.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1724,
    stopColor: "#05F0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3232,
    stopColor: "#0DE5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4658,
    stopColor: "#19D3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6035,
    stopColor: "#2BBAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7376,
    stopColor: "#4299E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8687,
    stopColor: "#5D71E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#7E43DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear",
    x1: 346.169,
    y1: 255.567,
    x2: 502.561,
    y2: 255.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022894"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear",
    x1: 345.169,
    y1: 255.568,
    x2: 503.561,
    y2: 255.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F42DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear",
    x1: 345.169,
    y1: 255.568,
    x2: 366.625,
    y2: 255.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear",
    x1: 491.215,
    y1: 255.568,
    x2: 503.561,
    y2: 255.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear",
    x1: 348.277,
    y1: 230.36,
    x2: 354.424,
    y2: 230.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear",
    x1: 357.014,
    y1: 230.36,
    x2: 363.161,
    y2: 230.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear",
    x1: 348.277,
    y1: 238.481,
    x2: 354.424,
    y2: 238.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear",
    x1: 357.014,
    y1: 238.481,
    x2: 363.161,
    y2: 238.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear",
    x1: 348.277,
    y1: 246.601,
    x2: 354.424,
    y2: 246.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear",
    x1: 357.014,
    y1: 246.601,
    x2: 363.161,
    y2: 246.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear",
    x1: 348.277,
    y1: 254.721,
    x2: 354.424,
    y2: 254.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear",
    x1: 357.014,
    y1: 254.721,
    x2: 363.161,
    y2: 254.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear",
    x1: 348.277,
    y1: 262.841,
    x2: 354.424,
    y2: 262.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear",
    x1: 357.014,
    y1: 262.841,
    x2: 363.161,
    y2: 262.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear",
    x1: 348.277,
    y1: 270.961,
    x2: 354.424,
    y2: 270.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear",
    x1: 357.014,
    y1: 270.961,
    x2: 363.161,
    y2: 270.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear",
    x1: 348.277,
    y1: 286.22,
    x2: 354.424,
    y2: 286.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear",
    x1: 357.014,
    y1: 286.22,
    x2: 363.161,
    y2: 286.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear",
    x1: 494.314,
    y1: 288.555,
    x2: 500.461,
    y2: 288.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear",
    x1: 494.314,
    y1: 274.776,
    x2: 500.461,
    y2: 274.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear",
    x1: 494.314,
    y1: 260.997,
    x2: 500.461,
    y2: 260.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear",
    x1: 494.314,
    y1: 247.217,
    x2: 500.461,
    y2: 247.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear",
    x1: 494.314,
    y1: 233.437,
    x2: 500.461,
    y2: 233.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear",
    x1: 345.169,
    y1: 219.828,
    x2: 503.561,
    y2: 219.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear",
    x1: 350.386,
    y1: 219.827,
    x2: 371.16,
    y2: 219.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear",
    x1: 374.493,
    y1: 219.827,
    x2: 395.268,
    y2: 219.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear",
    x1: 398.602,
    y1: 219.827,
    x2: 419.376,
    y2: 219.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear",
    x1: 422.71,
    y1: 219.827,
    x2: 443.485,
    y2: 219.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear",
    x1: 446.818,
    y1: 219.827,
    x2: 467.593,
    y2: 219.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear",
    x1: 374.875,
    y1: 260.09,
    x2: 430.123,
    y2: 260.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC20B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F24B89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear",
    x1: 440.996,
    y1: 272.147,
    x2: 481.456,
    y2: 272.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC20B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F24B89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear",
    x1: 411.444,
    y1: 244.809,
    x2: 469.302,
    y2: 244.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC20B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F24B89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear",
    x1: 398.468,
    y1: 288.772,
    x2: 459.265,
    y2: 288.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC20B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F24B89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear",
    x1: 292.574,
    y1: 407.937,
    x2: 373.487,
    y2: 407.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F03B9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1726,
    stopColor: "#F3557E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7419,
    stopColor: "#FCA925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear",
    x1: 313.727,
    y1: 436.481,
    x2: 315.754,
    y2: 436.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear",
    x1: 272.761,
    y1: 392.355,
    x2: 376.802,
    y2: 392.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear",
    x1: 308.704,
    y1: 453.698,
    x2: 354.718,
    y2: 453.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear",
    x1: 269.948,
    y1: 318.405,
    x2: 328.142,
    y2: 318.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear",
    x1: 283.622,
    y1: 318.201,
    x2: 322.422,
    y2: 318.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#964AE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear",
    x1: 236.28,
    y1: 318.2,
    x2: 306.774,
    y2: 318.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1393,
    stopColor: "#06EFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2898,
    stopColor: "#0FE2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4455,
    stopColor: "#1ECCF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6048,
    stopColor: "#33AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767,
    stopColor: "#4E87E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#6F58DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear",
    x1: 226.927,
    y1: 318.2,
    x2: 297.42,
    y2: 318.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear",
    x1: 277.96,
    y1: 385.736,
    x2: 338.653,
    y2: 385.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#964AE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear",
    x1: 276.96,
    y1: 385.736,
    x2: 339.653,
    y2: 385.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1724,
    stopColor: "#05F0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3232,
    stopColor: "#0DE5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4658,
    stopColor: "#19D3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6035,
    stopColor: "#2BBAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7376,
    stopColor: "#4299E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8687,
    stopColor: "#5D71E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#7E43DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear",
    x1: 234.031,
    y1: 385.736,
    x2: 313.492,
    y2: 385.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear",
    x1: 249.119,
    y1: 388.949,
    x2: 296.794,
    y2: 388.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC20B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F24B89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear",
    x1: 530.594,
    y1: 229.58,
    x2: 420.262,
    y2: 306.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03FBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1275,
    stopColor: "#29FCFC",
    stopOpacity: 0.8725
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4505,
    stopColor: "#83FDFE",
    stopOpacity: 0.5495
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    stopColor: "#C6FEFE",
    stopOpacity: 0.2867
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9028,
    stopColor: "#EFFFFF",
    stopOpacity: 0.0972
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear",
    x1: 557.54,
    y1: 275.939,
    x2: 581.451,
    y2: 275.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear",
    x1: 553.648,
    y1: 275.939,
    x2: 577.559,
    y2: 275.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear",
    x1: 570.018,
    y1: 279.757,
    x2: 587.135,
    y2: 279.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear",
    x1: 575.239,
    y1: 279.758,
    x2: 581.909,
    y2: 279.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03B9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear",
    x1: 542.992,
    y1: 220.222,
    x2: 564.64,
    y2: 220.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear",
    x1: 527.737,
    y1: 233.746,
    x2: 540.711,
    y2: 233.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03B9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear",
    x1: 518.99,
    y1: 232.284,
    x2: 557.701,
    y2: 232.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear",
    x1: 547.208,
    y1: 334.667,
    x2: 589.499,
    y2: 334.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear",
    x1: 646.072,
    y1: 406.581,
    x2: 653.846,
    y2: 406.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear",
    x1: 629.259,
    y1: 455.501,
    x2: 670.658,
    y2: 455.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear",
    x1: 644.557,
    y1: 351.947,
    x2: 655.361,
    y2: 351.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear",
    x1: 630.828,
    y1: 375.406,
    x2: 649.278,
    y2: 375.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear",
    x1: 623.17,
    y1: 392.231,
    x2: 649.325,
    y2: 392.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear",
    x1: 615.652,
    y1: 413.734,
    x2: 649.631,
    y2: 413.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear",
    x1: 650.639,
    y1: 375.406,
    x2: 669.089,
    y2: 375.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear",
    x1: 650.592,
    y1: 392.227,
    x2: 676.747,
    y2: 392.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear",
    x1: 650.286,
    y1: 413.734,
    x2: 684.265,
    y2: 413.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear",
    x1: 662.138,
    y1: 279.657,
    x2: 691.673,
    y2: 279.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear",
    x1: 673.825,
    y1: 242.813,
    x2: 679.986,
    y2: 242.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear",
    x1: 660.279,
    y1: 272.634,
    x2: 693.532,
    y2: 272.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear",
    x1: 678.123,
    y1: 249.22,
    x2: 686.342,
    y2: 249.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#964AE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear",
    x1: 677.123,
    y1: 249.219,
    x2: 687.344,
    y2: 249.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear",
    x1: 663.407,
    y1: 260.999,
    x2: 676.818,
    y2: 260.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#964AE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear",
    x1: 662.408,
    y1: 260.998,
    x2: 677.819,
    y2: 260.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear",
    x1: 667.093,
    y1: 243.924,
    x2: 677.314,
    y2: 243.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear",
    x1: 676.183,
    y1: 258.43,
    x2: 688.281,
    y2: 258.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear",
    x1: 678.123,
    y1: 228.068,
    x2: 686.342,
    y2: 228.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#964AE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear",
    x1: 677.123,
    y1: 228.068,
    x2: 687.344,
    y2: 228.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear",
    x1: 670.423,
    y1: 234.782,
    x2: 675.338,
    y2: 234.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#964AE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear",
    x1: 669.423,
    y1: 234.781,
    x2: 676.339,
    y2: 234.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F41DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear",
    x1: 667.093,
    y1: 222.774,
    x2: 677.315,
    y2: 222.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear",
    x1: 677.045,
    y1: 237.278,
    x2: 687.422,
    y2: 237.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear",
    x1: 399.181,
    y1: 277.799,
    x2: 384.424,
    y2: 298.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    stopColor: "#FA9A35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#F67160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    stopColor: "#F35480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    stopColor: "#F14193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03B9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear",
    x1: 279.594,
    y1: 246.822,
    x2: 320.599,
    y2: 246.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F03B9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1726,
    stopColor: "#F3557E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7419,
    stopColor: "#FCA925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear",
    x1: 269.873,
    y1: 236.612,
    x2: 322.695,
    y2: 236.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear",
    x1: 311.969,
    y1: 305.562,
    x2: 392.83,
    y2: 305.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear",
    x1: 559.045,
    y1: 177.922,
    x2: 559.045,
    y2: 196.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03B9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear",
    x1: 569.842,
    y1: 177.922,
    x2: 569.842,
    y2: 196.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03B9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear",
    x1: 580.637,
    y1: 177.462,
    x2: 580.637,
    y2: 196.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03B9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear",
    x1: 591.433,
    y1: 177.46,
    x2: 591.433,
    y2: 196.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03B9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear",
    x1: 324.5,
    y1: 168.423,
    x2: 324.5,
    y2: 149.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03B9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear",
    x1: 313.703,
    y1: 168.423,
    x2: 313.703,
    y2: 149.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03B9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear",
    x1: 302.908,
    y1: 168.883,
    x2: 302.908,
    y2: 149.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03B9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear",
    x1: 292.111,
    y1: 168.885,
    x2: 292.111,
    y2: 149.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03B9A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog1);
export default __webpack_public_path__ + "static/media/blog1.aa2f074c491ed977c89965b1cd400057.svg";
export { ForwardRef as ReactComponent };